/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import { Fragment, useEffect, useMemo, useRef, useState,  } from '@wordpress/element';
import { applyFilters } from '@wordpress/hooks';
import { dispatch, select, useSelect, subscribe } from '@wordpress/data';
import QRCode from 'qrcode';
import html2canvas from 'html2canvas';
import {
	darken,
	lighten
} from 'polished';
// editor style
import './editor.scss';
/**
 * Internal dependencies
 */
import Inspector from './inspector';
import { softMinifyCssStrings } from '../../helper/softminify';
import './style.scss';
import * as Controls from '../../controls';
import * as Constants from './constants';
import placeholderImageUrl from '../../../includes/assets/img/profile-image.png';
import BlockContext from './context/blockContext';
import * as Templates from '../../components/templates/index';
import loadGoogleFont from '../../options/load-goggle-font';
import { getThemeStyles } from '../../options/themeStyles';

// Import All Template Here
import TemplateOne from './templates/templateOne/templateOne.js';
import TemplateTwo from './templates/templateTwo/templateTwo.js';
import TemplateThree from './templates/templateThree/templateThree.js';


const { CustomPublishPreviewButtons } = Controls;


const hiddenSectionsByDefault = {
	style26: ['contact', 'hobbies', 'reference'],
	style27: ['hobbies', 'awards', 'reference'],
	style28: ['contact', 'hobbies', 'reference'],
};

// Hide 'award' and 'tools' for style1 to style25
for (let i = 1; i <= 28; i++) {
	const styleKey = `style${i}`;
	if (!hiddenSectionsByDefault[styleKey]) {
		hiddenSectionsByDefault[styleKey] = ['awards', 'tools'];
	}
}

const {
	MainTemplate,
	TemplateStyleOne,
	TemplateTwentyFour,
	TemplateTwentyFive,
	TemplateTwentyOne,
	TemplateTwentyTwo,
	InspectorTwentyOne,
	TemplateNineteen,
	TemplateTwelve,
	TemplateEleven,
	TemplateTen,
	TemplateStyleTwo,
	TemplateStyleFour,
	TemplateStyleFive,
	TemplateStyleSix,
	TemplateStyleSeven,
	TemplateStyleEight,
	TemplateStyleNine,
	TemplateStyleThirteen,
	TemplateStyleThree,
	TemplateStyleFourteen,
	TemplateStyleFifteen,
	TemplateSeventeen,
	TemplateStyleEighteen,
	TemplateTwenty,
	TemplateTwentyThree,
	TemplateStyleSixteen,
} = Templates;

// Edit Function
export default function Edit({ attributes, setAttributes, clientId }) {
	const {
		uniqueId,
		sectionItems,
		sectionItems1,
		sectionItems2,
		sectionItems4,
		sectionItems5,
		sectionItems6,
		sectionItems3,
		sectionItems7,
		sectionItems8,
		sectionItems9,
		sectionItems10,
		sectionItems11,
		sectionItems12,
		sectionItems13,
		sectionItems14,
		sectionItems15,
		sectionItems16,
		sectionItems17,
		sectionItems18,
		sectionItems19,
		sectionItems20,
		sectionItems21,
		sectionItems22,
		sectionItems23,
		sectionItems24,
		sectionItems25,
		sectionItems26,
		sectionItems27,
		sectionItems28,
		isAboutVisible,
		isContactVisible,
		isSkillsVisible,
		isLanguageVisible,
		isHobbyVisible,
		isEducationVisible,
		isExperienceVisible,
		isReferenceVisible,
		isFooterVisible,
		style,
		blockStyle,
		email,
		phoneNumber,
		hasInitialized,
		customHasInitialized,
		dataByStyle,
		showQRCode,
		themeColor,
		typography,
		headerBackgroundColor, 
		aboutTitleColor,
		aboutTitleBgColor,
		aboutNationalityColor,
		aboutDateOfBirthColor,
		aboutDescriptionColor,
		aboutTitleIconColor,
		aboutDescColor,
		addressColor,
		DateOfBirthColor,
		nationalityColor,
		contactTitleColor,
		contactTitleBgColor,
		contactTitleIconColor,
		contactContentColor,
		skillsTitleColor,
		skillNameColor,
		skillPercentageColor,
		skillProgressTopColor,
		skillProgressBottomColor,
		languageTitleColor,
		languageTitleBgColor,
		languageTitleIconColor,
		languageNameColor,
		languagePercentageColor,
		languageProgressTopColor,
		languageProgressBottomColor,
		hobbiesTitleColor,
		hobbiesTitleBgColor,
		hobbiesTitleIconColor,
		hobbyNameColor,
		hobbyIconColor,
		educationTitleColor,
		educationTitleBgColor,
		educationTitleIconColor,
		educationDescriptionColor,
		educationYearColor,
		educationRoundShapeColor,
		educationLineColor,
		studyFieldColor,
		degreeNameColor,
		institutionColor,
		experienceTitleColor,
		experienceTitleBgColor,
		experienceTitleIconColor,
		experienceDescriptionColor,
		experienceCompanyNameColor,
		experienceDesignationColor,
		experienceDurationColor,
		experienceRoundShapeColor,
		experienceLineColor,
		referenceTitleColor,
		referenceTitleBgColor,
		referenceTitleIconColor,
		referenceNameColor,
		referenceContentColor,
		skillsTitleBgColor,
		skillsTitleIconColor,
		awardNameColor,
		awardArrowColor,
		awardTitleColor,
		awardTitleBgColor,
		awardTitleIconColor,
		toolsNameColor,
		toolsArrowColor,
		toolsTitleColor,
		toolsTitleBgColor,
		toolsTitleIconColor,
		sectionCountOne,
		sectionCountTwo,
		footerBgColor,
		bodyBgColor,
		leftColumnBgColor,
		rightColumnBgColor,
		userNameColor,
		designationColor,
		iconColor,
		iconBackgroundColor,
		skillTitleBgColor,
		skillTitleColor,
		skillTitleIconColor,
		skillTopBgColor,
		skillBottomBgColor,
		languageTopBgColor,
		languageBottomBgColor,
		hobbyTitleBgColor,
		hobbyTitleColor,
		hobbyTitleIconColor,
		institutionNameColor,
		educationPassingDateColor,
		companyNameColor,
		experienceDateColor,
		referenceJobPositionColor,
		referenceCompanyColor,
		referencePhoneColor,
		referenceRelationColor,
		userNameTypography,
		designationTypography,
		aboutTitleTypography,
		aboutDescriptionTypography,
		images
	} = attributes;

	const {
			NAME_FONT_SIZE,
			DESIGNATION_FONT_SIZE,
			IMAGE_SIZE,
			IMAGE_BORDER_RADIUS,
			ICON_BORDER_RADIUS,
			ICON_SIZE,
			ICON_GAP,
			ICON_ROUND_SIZE,
			QR_POSITION_HORIZONTAL,
			QR_POSITION_VERTICAL,
			NATIONALITY_FONT_SIZE,
			ABOUT_TITLE_FONT_SIZE,
			ABOUT_TITLE_ICON_FONT_SIZE,
			ABOUT_DESCRIPTION_FONT_SIZE,
			DATE_OF_BIRTH_FONT_SIZE,
			CONTACT_FONT_SIZE,
			SKILL_TITLE_FONT_SIZE,
			SKILL_TITLE_ICON_FONT_SIZE,
			SKILL_NAME_FONT_SIZE,
			SKILL_PERCENTAGE_FONT_SIZE,
			SKILL_BAR_GAP,
			LANGUAGE_TITLE_FONT_SIZE,
			LANGUAGE_TITLE_ICON_FONT_SIZE,
			LANGUAGE_NAME_FONT_SIZE,
			LANGUAGE_PERCENTAGE_FONT_SIZE,
			LANGUAGE_BAR_GAP,
			HOBBY_TITLE_FONT_SIZE,
			HOBBY_TITLE_ICON_FONT_SIZE,
			HOBBY_NAME_FONT_SIZE,
			HOBBY_ICON_FONT_SIZE,
			HOBBY_ITEM_GAP,
			EDUCATION_TITLE_FONT_SIZE,
			EDUCATION_TITLE_ICON_FONT_SIZE,
			EDUCATION_PASSING_YEAR_FONT_SIZE,
			INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE,
			STUDY_FIELD_FONT_SIZE,
			EDUCATION_DEGREE_NAME_FONT_SIZE,
			EDUCATION_DESCRIPTION_FONT_SIZE,
			REFERENCE_TITLE_FONT_SIZE,
			REFERENCE_TITLE_ICON_FONT_SIZE,
			REFERENCE_NAME_FONT_SIZE,
			REFERENCE_JOB_POSITION_FONT_SIZE,
			REFERENCE_COMPANY_FONT_SIZE,
			REFERENCE_PHONE_FONT_SIZE,
			REFERENCE_RELATION_FONT_SIZE,
			EXPERIENCE_TITLE_FONT_SIZE,
			EXPERIENCE_TITLE_ICON_FONT_SIZE,
			EXPERIENCE_COMPANY_FONT_SIZE,
			EXPERIENCE_DESIGNATION_FONT_SIZE,
			EXPERIENCE_DESCRIPTION_FONT_SIZE,
			EXPERIENCE_DATE_FONT_SIZE,
			ABOUT_PADDING_TOP,
			ABOUT_PADDING_RIGHT,
			ABOUT_PADDING_BOTTOM,
			ABOUT_PADDING_LEFT,
			ABOUT_BORDER_RADIUS_TOP,
			ABOUT_BORDER_RADIUS_RIGHT,
			ABOUT_BORDER_RADIUS_BOTTOM,
			ABOUT_BORDER_RADIUS_LEFT,
			CONTACT_PADDING_TOP,
			CONTACT_PADDING_RIGHT,
			CONTACT_PADDING_BOTTOM,
			CONTACT_PADDING_LEFT,
			CONTACT_BORDER_RADIUS_TOP,
			CONTACT_BORDER_RADIUS_RIGHT,
			CONTACT_BORDER_RADIUS_BOTTOM,
			CONTACT_BORDER_RADIUS_LEFT,
			SKILL_PADDING_TOP,
			SKILL_PADDING_RIGHT,
			SKILL_PADDING_BOTTOM,
			SKILL_PADDING_LEFT,
			SKILL_BORDER_RADIUS_TOP,
			SKILL_BORDER_RADIUS_RIGHT,
			SKILL_BORDER_RADIUS_BOTTOM,
			SKILL_BORDER_RADIUS_LEFT,
			LANGUAGE_PADDING_TOP,
			LANGUAGE_PADDING_RIGHT,
			LANGUAGE_PADDING_BOTTOM,
			LANGUAGE_PADDING_LEFT,
			LANGUAGE_BORDER_RADIUS_TOP,
			LANGUAGE_BORDER_RADIUS_RIGHT,
			LANGUAGE_BORDER_RADIUS_BOTTOM,
			LANGUAGE_BORDER_RADIUS_LEFT,
			HOBBY_PADDING_TOP,
			HOBBY_PADDING_RIGHT,
			HOBBY_PADDING_BOTTOM,
			HOBBY_PADDING_LEFT,
			HOBBY_BORDER_RADIUS_TOP,
			HOBBY_BORDER_RADIUS_RIGHT,
			HOBBY_BORDER_RADIUS_BOTTOM,
			HOBBY_BORDER_RADIUS_LEFT,
			EDUCATION_PADDING_BOTTOM,
			EDUCATION_PADDING_TOP,
			EDUCATION_PADDING_LEFT,
			EDUCATION_PADDING_RIGHT,
			EDUCATION_BORDER_RADIUS_BOTTOM,
			EDUCATION_BORDER_RADIUS_TOP,
			EDUCATION_BORDER_RADIUS_LEFT,
			EDUCATION_BORDER_RADIUS_RIGHT,
			EXPERIENCE_PADDING_BOTTOM,
			EXPERIENCE_PADDING_TOP,
			EXPERIENCE_PADDING_LEFT,
			EXPERIENCE_PADDING_RIGHT,
			EXPERIENCE_BORDER_RADIUS_BOTTOM,
			EXPERIENCE_BORDER_RADIUS_TOP,
			EXPERIENCE_BORDER_RADIUS_LEFT,
			EXPERIENCE_BORDER_RADIUS_RIGHT,
			REFERENCE_PADDING_BOTTOM,
			REFERENCE_PADDING_TOP,
			REFERENCE_PADDING_LEFT,
			REFERENCE_PADDING_RIGHT,
			REFERENCE_BORDER_RADIUS_BOTTOM,
			REFERENCE_BORDER_RADIUS_TOP,
			REFERENCE_BORDER_RADIUS_LEFT,
			REFERENCE_BORDER_RADIUS_RIGHT,
			ABOUT_SECTION_PADDING_TOP,
			ABOUT_SECTION_PADDING_RIGHT,
			ABOUT_SECTION_PADDING_BOTTOM,
			ABOUT_SECTION_PADDING_LEFT,
			CONTACT_SECTION_PADDING_TOP,
			CONTACT_SECTION_PADDING_RIGHT,
			CONTACT_SECTION_PADDING_BOTTOM,
			CONTACT_SECTION_PADDING_LEFT,
			SKILL_SECTION_PADDING_TOP,
			SKILL_SECTION_PADDING_RIGHT,
			SKILL_SECTION_PADDING_BOTTOM,
			SKILL_SECTION_PADDING_LEFT,
			LANGUAGE_SECTION_PADDING_TOP,
			LANGUAGE_SECTION_PADDING_RIGHT,
			LANGUAGE_SECTION_PADDING_BOTTOM,
			LANGUAGE_SECTION_PADDING_LEFT,
			HOBBY_SECTION_PADDING_TOP,
			HOBBY_SECTION_PADDING_RIGHT,
			HOBBY_SECTION_PADDING_BOTTOM,
			HOBBY_SECTION_PADDING_LEFT,
			EDUCATION_SECTION_PADDING_TOP,
			EDUCATION_SECTION_PADDING_RIGHT,
			EDUCATION_SECTION_PADDING_BOTTOM,
			EDUCATION_SECTION_PADDING_LEFT,
			EXPERIENCE_SECTION_PADDING_TOP,
			EXPERIENCE_SECTION_PADDING_RIGHT,
			EXPERIENCE_SECTION_PADDING_BOTTOM,
			EXPERIENCE_SECTION_PADDING_LEFT,
			REFERENCE_SECTION_PADDING_TOP,
			REFERENCE_SECTION_PADDING_RIGHT,
			REFERENCE_SECTION_PADDING_BOTTOM,
			REFERENCE_SECTION_PADDING_LEFT,
			HEADER_PADDING_TOP,
			HEADER_PADDING_RIGHT,
			HEADER_PADDING_BOTTOM,
			HEADER_PADDING_LEFT,
			FOOTER_PADDING_TOP,
			FOOTER_PADDING_RIGHT,
			FOOTER_PADDING_BOTTOM,
			FOOTER_PADDING_LEFT,
		} = Constants;
	// Get correct sectionItems based on style
	const getSectionItems = () => {
		switch (style) {
			case 'style26':
				return sectionItems26 || [];
			case 'style27':
				return sectionItems27 || [];
			case 'style28':
				return sectionItems28 || [];			
			case 'style11':
				return sectionItems11 || [];
			case 'style10':
				return sectionItems10 || [];
			case 'style2':
				return sectionItems2 || [];
			case 'style3':
				return sectionItems3 || [];
			case 'style4':
				return sectionItems4 || [];
			case 'style5':
				return sectionItems5 || [];
			case 'style6':
				return sectionItems6 || [];
			case 'style7':
				return sectionItems7 || [];
			case 'style8':
				return sectionItems8 || [];
			case 'style9':
				return sectionItems9 || [];
			case 'style12':
				return sectionItems12 || [];
			case 'style13':
				return sectionItems13 || [];
			case 'style14':
				return sectionItems14 || [];
			case 'style15':
				return sectionItems15 || [];
			case 'style16':
				return sectionItems16 || [];
			case 'style17':
				return sectionItems17 || [];
			case 'style18':
				return sectionItems18 || [];
			case 'style19':
				return sectionItems19 || [];
			case 'style20':
				return sectionItems20 || [];
			case 'style21':
				return sectionItems21 || [];
			case 'style22':
				return sectionItems22 || [];
			case 'style23':
				return sectionItems23 || [];
			case 'style24':
				return sectionItems24 || [];
			case 'style25':
				return sectionItems25 || [];
			case 'style1':
				return sectionItems1 || [];
			default:
				return sectionItems || [];
		}
	};

	// Set correct sectionItems based on style
	const setSectionItems = (newItems) => {
		switch (style) {
			case 'style26':
				setAttributes({ sectionItems26: newItems });
				break;
			case 'style27':
				setAttributes({ sectionItems27: newItems });
				break;
			case 'style28':
				setAttributes({ sectionItems28: newItems });
				break;
			case 'style11':
				setAttributes({ sectionItems11: newItems });
				break;
			case 'style10':
				setAttributes({ sectionItems10: newItems });
				break;
			case 'style2':
				setAttributes({ sectionItems2: newItems });
				break;
			case 'style3':
				setAttributes({ sectionItems3: newItems });
				break;
			case 'style4':
				setAttributes({ sectionItems4: newItems });
				break;
			case 'style5':
				setAttributes({ sectionItems5: newItems });
				break;
			case 'style6':
				setAttributes({ sectionItems6: newItems });
				break;
			case 'style7':
				setAttributes({ sectionItems7: newItems });
				break;
			case 'style8':
				setAttributes({ sectionItems8: newItems });
				break;
			case 'style9':
				setAttributes({ sectionItems9: newItems });
				break;
			case 'style12':
				setAttributes({ sectionItems12: newItems });
				break;
			case 'style13':
				setAttributes({ sectionItems13: newItems });
				break;
			case 'style14':
				setAttributes({ sectionItems14: newItems });
				break;
			case 'style15':
				setAttributes({ sectionItems15: newItems });
				break;
			case 'style16':
				setAttributes({ sectionItems16: newItems });
				break;
			case 'style17':
				setAttributes({ sectionItems17: newItems });
				break;
			case 'style18':
				setAttributes({ sectionItems18: newItems });
				break;
			case 'style19':
				setAttributes({ sectionItems19: newItems });
				break;
			case 'style20':
				setAttributes({ sectionItems20: newItems });
				break;
			case 'style21':
				setAttributes({ sectionItems21: newItems });
				break;
			case 'style22':
				setAttributes({ sectionItems22: newItems });
				break;
			case 'style23':
				setAttributes({ sectionItems23: newItems });
				break;
			case 'style24':
				setAttributes({ sectionItems24: newItems });
				break;
			case 'style25':
				setAttributes({ sectionItems25: newItems });
				break;
			case 'style1':
				setAttributes({ sectionItems1: newItems });
				break;
			default:
				setAttributes({ sectionItems: newItems });
				break;
		}
	};
	const updateSectionTitle = (index, newTitle) => {
		const newSectionItems = [...sectionItems]
		newSectionItems[index] = {
		  ...newSectionItems[index],
		  title: newTitle,
		}
		setAttributes({ sectionItems: newSectionItems })
	  }
	const formatDate = (dateString) => {
		if (!dateString) return __("Not specified", "cv-builder");
		const date = new Date(dateString);
		const day = date.getDate().toString().padStart(2, "0");
		const month = (date.getMonth() + 1).toString().padStart(2, "0");
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	const formatDateDisplay = (dateString) => {
		if (!dateString) return '';
		try {
			const [year, month] = dateString.split('-');
			if (!year || !month) {
				return dateString;
			}
			return `${year}/${month.padStart(2, '0')}`;
		} catch (error) {
			return dateString;
		}
	};

	const updateField = (sectionIndex, field, newValue, itemIndex) => {
        const currentSectionItems = getSectionItems();
        const updatedSections = currentSectionItems.map((section, secIdx) => {
            if (secIdx === sectionIndex) {
                if (itemIndex !== undefined) {
                    return {
                        ...section,
                        items: section.items.map((item, idx) =>
                            idx === itemIndex ? { ...item, [field]: newValue } : item
                        ),
                    };
                }
                return {
                    ...section,
                    [field]: newValue,
                };
            }
            return section;
        });
        setSectionItems(updatedSections);
    };

	useEffect(() => {
		const currentItems = getSectionItems();
		const initialized = hasInitialized?.[style] || false;
		const shouldInitialize = !initialized && currentItems.length > 0;
		if (shouldInitialize) {
			const sectionsToHide = hiddenSectionsByDefault[style] || [];
			let updatedItems = [...currentItems];
			let hasChanges = false;
			sectionsToHide.forEach(sectionType => {
				if (updatedItems.some(section => section.type === sectionType)) {
					updatedItems = updatedItems.filter(section => section.type !== sectionType);
					hasChanges = true;
				}
			});
			if (hasChanges) {
				setSectionItems(updatedItems);
			}
			setAttributes({
				hasInitialized: {
					...hasInitialized,
					[style]: true,
				},
			});
		}
	}, [hasInitialized, sectionItems26, sectionItems27, sectionItems28, style, sectionItems1, sectionItems2, sectionItems3, sectionItems4, sectionItems5, sectionItems6, sectionItems7, sectionItems8, sectionItems9, sectionItems10, sectionItems11, sectionItems12, sectionItems13, sectionItems14, sectionItems15, sectionItems16, sectionItems17, sectionItems18, sectionItems19, sectionItems20, sectionItems21, sectionItems22, sectionItems23, sectionItems24, sectionItems25]);

	useEffect(() => {
		if (!dataByStyle?.[style]) {
			const updated = {
				...dataByStyle,
				[style]: {
					firstName: '',
					lastName: '',
					designation: '',
					phoneNumber: '',
					email: '',
				},
			};
			setAttributes({ dataByStyle: updated });
		}
	}, []);

	const formatMonthDisplay = (dateString) => {
		if (!dateString) return '';

		try {
			const date = new Date(dateString);

			if (isNaN(date.getTime())) {
				return dateString;
			}

			return date.toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'short'
			});
		} catch (error) {
			return dateString;
		}
	};

	useEffect(() => {
		function initProgressBars() {
			const CVPBArea = document.querySelectorAll('.bwdcv-pb-area');
			function setValueWithoutAnimation(counter, progressBar, value) {
				counter.textContent = value + '%';
			}
			function CVProgressBar(progressWrapper) {
				const bwdProgressBox =
					progressWrapper.querySelectorAll('.bwdcv-pb-name');
				bwdProgressBox.forEach((pbBox) => {
					const allPB = pbBox.querySelector('.bwdcv-per-val');
					const progressBar = pbBox.querySelector(
						'.bwdcv-progress-bar'
					);
					const counter = pbBox.querySelector(
						'.bwdcv-percentage-counter'
					);
					const allPBVal = parseInt(
						allPB.getAttribute('data-pb-val')
					);
					allPB.style.width = allPBVal + '%';
					setValueWithoutAnimation(counter, progressBar, allPBVal);
				});
			}
			CVPBArea.forEach((area) => {
				CVProgressBar(area);
			});
		}
		initProgressBars();
		// Hide Sidebar Control
		if(!userData.isAdmin) {
			const sidebarIsOpen = select('core/edit-post').isEditorSidebarOpened();
			const activeBlock = select('core/block-editor').getSelectedBlockClientId();
			if (!sidebarIsOpen || activeBlock !== clientId) {
				dispatch('core/edit-post').openGeneralSidebar('edit-post/block');
				dispatch('core/block-editor').selectBlock(clientId);
			}
		}

		// // Auto Save
		const autoSaveInterval = setInterval(() => {
			const isPostDirty = select('core/editor').isEditedPostDirty();
			if (isPostDirty) {
				dispatch('core/editor').savePost();
			}
		}, 1000);

		return () => clearInterval(autoSaveInterval);
	}, [
		clientId,
		isSkillsVisible,
		isAboutVisible,
		isContactVisible,
		isLanguageVisible,
		isHobbyVisible,
		isEducationVisible,
		isExperienceVisible,
		isReferenceVisible,
		isFooterVisible,
		style,
		sectionItems1,
		sectionItems2,
		sectionItems3,
		sectionItems4,
		sectionItems5,
		sectionItems6,
		sectionItems7,
		sectionItems8,
		sectionItems9,
		sectionItems10,
		sectionItems11,
		sectionItems12,
		sectionItems13,
		sectionItems14,
		sectionItems15,
		sectionItems16,
		sectionItems17,
		sectionItems18,
		sectionItems19,
		sectionItems20,
		sectionItems21,
		sectionItems22,
		sectionItems23,
		sectionItems24,
		sectionItems25,
		sectionItems26,
		sectionItems27,
		sectionItems28,
		sectionCountOne,
		sectionCountTwo,
		style
	]);

	useEffect(() => {
		const checkElement = setInterval(() => {
			const button = document.querySelector(".interface-pinned-items > button:last-child");
			const removeButton = document.querySelector(".interface-pinned-items > button:not(:last-child)");
			const buttonSVG = document.querySelector(".interface-pinned-items button svg");
			if (button) {
				buttonSVG ? buttonSVG.remove() : '';
				removeButton ? removeButton.remove() : '';
				const editIcon = document.createElement("i");
				editIcon.className = "fa-solid fa-pen-to-square";
				const prevIcon = document.createElement("i");
				prevIcon.className = "fa-solid fa-eye";
				const editText = document.createElement("span");
				editText.innerText = " Edit";
				editText.className = "edittext";
				const prevText = document.createElement("span");
				prevText.innerText = "Preview";
				prevText.className = "prevtext";
				button.appendChild(editIcon);
				button.appendChild(prevIcon);
				button.appendChild(editText);
				button.appendChild(prevText);
				clearInterval(checkElement);
			}
		}, 100);
		return () => clearInterval(checkElement);
	}, []);
	
	const templates = userData?.cvTemplates || [];
	const isCustomTemplate = !isNaN(Number(style));
	const matchedTemplate = isCustomTemplate
		? templates?.find((template) => String(template.id) === String(style))
		: null;

	// Track replacement state
	const isReplacedRef = useRef(false);
	const lastReplacedStyle = useRef(null);
	useEffect(() => {
		if (lastReplacedStyle.current !== style) {
			isReplacedRef.current = false;
		}
	}, [style]);

	useEffect(() => {
		const templateContent = matchedTemplate?.content;		
		if (!templateContent) {
			return;
		}	
		const templateBlocks = wp.blocks.parse(templateContent);
		if (!templateBlocks || templateBlocks.length === 0) {
			return;
		}	
		wp.data.dispatch('core/block-editor').resetBlocks(templateBlocks);
		wp.data.dispatch('core/editor').editPost({
			content: templateContent
		});
		isReplacedRef.current = true;
		lastReplacedStyle.current = style;
	}, [matchedTemplate, style]);
	
	const captureRef = useRef();
	useEffect(() => {
		try {
		  let previousStatus = select('core/editor').getCurrentPost().status;
		  let isGeneratingScreenshot = false;
		  let hasContentChanged = false;
		  
		  const unsubscribe = subscribe(() => {
			try {
			  if (isGeneratingScreenshot) return;
			  
			  const editorSelect = select('core/editor');
			  if (!editorSelect) return;
			  
			  const currentPost = editorSelect.getCurrentPost();
			  if (!currentPost || currentPost.type !== 'cv-templates') return;
			  
			  const isSaving = editorSelect.isSavingPost();
			  const isAutosaving = editorSelect.isAutosavingPost();
			  const didSaveSucceed = editorSelect.didPostSaveRequestSucceed();
			  const isPublished = ['publish', 'private'].includes(currentPost.status);
			  if (!isSaving && !isAutosaving && editorSelect.isEditedPostDirty()) {
				hasContentChanged = true;
			  }
			  
			  const isBeingPublished = previousStatus !== 'publish' && 
									  currentPost.status === 'publish' && 
									  !isSaving && 
									  didSaveSucceed;
			  
			  const justSaved = !isSaving && 
								didSaveSucceed && 
								isPublished && 
								hasContentChanged;
			  
			  if (isBeingPublished || justSaved) {
				previousStatus = currentPost.status;
				hasContentChanged = false;
				isGeneratingScreenshot = true;
				if(bwdcv_data?.licenseStatus === "activate") {
				generateScreenshot().finally(() => {
				  isGeneratingScreenshot = false;
				  if (editorSelect.isEditedPostDirty()) {
					setTimeout(() => {
					  dispatch('core/editor').savePost();
					}, 100);
				  }
				});
				}
			  }
			} catch (error) {
			  console.error('Error in editor subscribe callback:', error);
			}
		  });
		  
		  return () => {
			try {
			  unsubscribe();
			} catch (e) {
			  // Ignore unsubscribe errors
			}
		  };
		} catch (error) {
		  return () => {};
		}
	  }, []);

	const generateScreenshot = async () => {
		try {
			if (!captureRef.current) {
			return;
			}
			const currentPostId = wp.data.select('core/editor').getCurrentPostId();		
			const canvas = await html2canvas(captureRef.current, {
			scale: 2,
			useCORS: true,
			allowTaint: false,
			backgroundColor: '#FFFFFF',
			logging: false,
			onclone: (document, element) => {
				if (element) {
				element.style.opacity = '1';
				element.style.transform = 'none';
				element.style.display = 'block';
				}
				return document;
			}
			});		
			const blob = await new Promise(resolve => {
			canvas.toBlob(resolve, 'image/jpeg', 0.85);
			});
			
			const file = new File([blob], `template-${currentPostId}.jpg`, { type: 'image/jpeg' });		
			const formData = new FormData();
			formData.append('action', 'bwdcv_upload_template_screenshot');
			formData.append('security', userData.nonce);
			formData.append('template_id', currentPostId);
			formData.append('file', file);
			formData.append('update_block', 'true');
			
			const response = await fetch(userData.ajaxUrl, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin',
			});
			
			const result = await response.json();
			
			if (!result.success) {
			throw new Error(result.data || 'Upload failed');
			}
			const currentTemplateId = String(currentPostId);
			const existingImageIndex = images.findIndex(img => img.value === currentTemplateId);
			const labelNumber = existingImageIndex >= 0 
			? parseInt(images[existingImageIndex].label.match(/\d+/)[0]) 
			: (29 + images.length);
			
			const newStyle = {
			value: currentTemplateId,
			label: `Style ${labelNumber}`,
			imageUrl: result.data.url,
			};
			
			let updatedImages;
			if (existingImageIndex >= 0) {
			updatedImages = [...images];
			updatedImages[existingImageIndex] = newStyle;
			} else {
			updatedImages = [...images, newStyle];
			}
			
			setAttributes({
			images: updatedImages,
			});
			
			return true;
		} catch (error) {
			return false;
		}
	};

	
	// Hooks Declaration
	useEffect(() => {
		if (userData?.userEmail) {
			setAttributes({ email: userData.userEmail });
		}
	}, []);

	if (!customHasInitialized) {
		applyFilters('bwdcv.removeDefaultValue', null, {
			sectionItems,
			setAttributes,
		});
		setAttributes({ customHasInitialized: true });
	}

	const showSocialIcon = applyFilters('show_editor_social_info', true);
	const footerVisibility = applyFilters('bwdcv-footer-visibility', true);
	const socialIconVisibility = applyFilters(
		'bwdcv-social-icon-visibility',
		true
	);
	const emailPhoneVisibility = applyFilters(
		'bwdcv-email-phone-visibility',
		true
	);
	const dashPreviewBanner = applyFilters('bwdcv-dash-preview-banner', true);
	const headerComponent = applyFilters('bwdcv.emailPhoneHeader', null, {
		email,
		phoneNumber,
		setAttributes,
	});
	const linkedinText = applyFilters('bwdcv.linkedinText', null);

	// unique id
	useEffect(() => {
		setAttributes({
			uniqueId: `wp-cv-builder-${clientId.slice(0, 8)}`,
		});
	}, [clientId]);

	// function to convert object to css
	const convertToCss = (obj) => {
		let cssResult;
		Object.keys(obj).reduce((cssString, key) => {
			// change key to css property
			const cssProperty = key.replace(
				/[A-Z]/g,
				(match) => `-${match.toLowerCase()}`
			);
			cssResult = `${cssString}${cssProperty}:${obj[key]};`;
			return cssResult;
		}, '');
		return cssResult;
	};

	// Name Font Size
	const deskNameFontSize = attributes[`${NAME_FONT_SIZE}DeskRange`];
	const nameFontSizeUnit = attributes[`${NAME_FONT_SIZE}Unit`];
	// Image Size
	const deskImageSize = attributes[`${IMAGE_SIZE}DeskRange`];
	const imageSizeUnit = attributes[`${IMAGE_SIZE}Unit`];
	// Image Border Radius
	const deskImageBorderRadius = attributes[`${IMAGE_BORDER_RADIUS}DeskRange`];
	const imageBorderRadiusUnit = attributes[`${IMAGE_BORDER_RADIUS}Unit`];
	// Designation Font Size
	const deskDesignationFontSize =
		attributes[`${DESIGNATION_FONT_SIZE}DeskRange`];
	const designationFontSizeUnit = attributes[`${DESIGNATION_FONT_SIZE}Unit`];
	// Icon Size
	const deskIconSize = attributes[`${ICON_SIZE}DeskRange`];
	const iconSizeUnit = attributes[`${ICON_SIZE}Unit`];
	// Icon Border Radius
	const deskIconBorderRadius = attributes[`${ICON_BORDER_RADIUS}DeskRange`];
	const iconBorderRadiusUnit = attributes[`${ICON_BORDER_RADIUS}Unit`];
	// QR Position
	// const deskQRPositionHorizontal =
	// 	attributes[`${QR_POSITION_HORIZONTAL}DeskRange`];
	// const deskQRPositionVertical =
	// 	attributes[`${QR_POSITION_VERTICAL}DeskRange`];
	// const qrPositionHorizontalUnit =
	// 	attributes[`${QR_POSITION_HORIZONTAL}Unit`];
	// const qrPositionVerticalUnit = attributes[`${QR_POSITION_VERTICAL}Unit`];
	// Icon Gap
	const deskIconGap = attributes[`${ICON_GAP}DeskRange`];
	const iconGapUnit = attributes[`${ICON_GAP}Unit`];
	// Icon Round Size
	const deskIconRoundSize = attributes[`${ICON_ROUND_SIZE}DeskRange`];
	const iconRoundSizeUnit = attributes[`${ICON_ROUND_SIZE}Unit`];
	// About Title Font Size
	const deskAboutTitleFontSize =
		attributes[`${ABOUT_TITLE_FONT_SIZE}DeskRange`];
	const aboutTitleFontSizeUnit = attributes[`${ABOUT_TITLE_FONT_SIZE}Unit`];
	// About Title Icon Font Size
	const deskAboutTitleIconFontSize =
		attributes[`${ABOUT_TITLE_ICON_FONT_SIZE}DeskRange`];
	const aboutTitleIconFontSizeUnit =
		attributes[`${ABOUT_TITLE_ICON_FONT_SIZE}Unit`];
	// About Description Font Size
	const deskAboutDescriptionFontSize =
		attributes[`${ABOUT_DESCRIPTION_FONT_SIZE}DeskRange`];
	const aboutDescriptionFontSizeUnit =
		attributes[`${ABOUT_DESCRIPTION_FONT_SIZE}Unit`];
	// Date Of Birth Font Size
	const deskDateOfBirthFontSize =
		attributes[`${DATE_OF_BIRTH_FONT_SIZE}DeskRange`];
	const dateOfBirthFontSizeUnit =
		attributes[`${DATE_OF_BIRTH_FONT_SIZE}Unit`];
	// Nationality Font Size
	const deskNationalityFontSize =
		attributes[`${NATIONALITY_FONT_SIZE}DeskRange`];
	const nationalityFontSizeUnit = attributes[`${NATIONALITY_FONT_SIZE}Unit`];
	// Contact Font Size
	const deskContactFontSize = attributes[`${CONTACT_FONT_SIZE}DeskRange`];
	const contactFontSizeUnit = attributes[`${CONTACT_FONT_SIZE}Unit`];
	// Skills Title Font Size
	const deskSkillTitleFontSize =
		attributes[`${SKILL_TITLE_FONT_SIZE}DeskRange`];
	const skillTitleFontSizeUnit = attributes[`${SKILL_TITLE_FONT_SIZE}Unit`];
	// Skills Title Icon Font Size
	const deskSkillTitleIconFontSize =
		attributes[`${SKILL_TITLE_ICON_FONT_SIZE}DeskRange`];
	const skillTitleIconFontSizeUnit =
		attributes[`${SKILL_TITLE_ICON_FONT_SIZE}Unit`];
	// Skills Name Font Size
	const deskSkillNameFontSize =
		attributes[`${SKILL_NAME_FONT_SIZE}DeskRange`];
	const skillNameFontSizeUnit = attributes[`${SKILL_NAME_FONT_SIZE}Unit`];
	// Skills Percentage Font Size
	const deskSkillPercentageFontSize =
		attributes[`${SKILL_PERCENTAGE_FONT_SIZE}DeskRange`];
	const skillPercentageFontSizeUnit =
		attributes[`${SKILL_PERCENTAGE_FONT_SIZE}Unit`];
	// Languages Title Font Size
	const deskLanguageTitleFontSize =
		attributes[`${LANGUAGE_TITLE_FONT_SIZE}DeskRange`];
	const languageTitleFontSizeUnit =
		attributes[`${LANGUAGE_TITLE_FONT_SIZE}Unit`];
	// Languages Title Icon Font Size
	const deskLanguageTitleIconFontSize =
		attributes[`${LANGUAGE_TITLE_ICON_FONT_SIZE}DeskRange`];
	const languageTitleIconFontSizeUnit =
		attributes[`${LANGUAGE_TITLE_ICON_FONT_SIZE}Unit`];
	// Languages Name Font Size
	const deskLanguageNameFontSize =
		attributes[`${LANGUAGE_NAME_FONT_SIZE}DeskRange`];
	const languageNameFontSizeUnit =
		attributes[`${LANGUAGE_NAME_FONT_SIZE}Unit`];
	// Languages Percentage Font Size
	const deskLanguagePercentageFontSize =
		attributes[`${LANGUAGE_PERCENTAGE_FONT_SIZE}DeskRange`];
	const languagePercentageFontSizeUnit =
		attributes[`${LANGUAGE_PERCENTAGE_FONT_SIZE}Unit`];
	// Hobby Title Font Size
	const deskHobbyTitleFontSize =
		attributes[`${HOBBY_TITLE_FONT_SIZE}DeskRange`];
	const hobbyTitleFontSizeUnit = attributes[`${HOBBY_TITLE_FONT_SIZE}Unit`];
	// Hobby Title Icon Font Size
	const deskHobbyTitleIconFontSize =
		attributes[`${HOBBY_TITLE_ICON_FONT_SIZE}DeskRange`];
	const hobbyTitleIconFontSizeUnit =
		attributes[`${HOBBY_TITLE_ICON_FONT_SIZE}Unit`];
	// Hobby Name Font Size
	const deskHobbyNameFontSize =
		attributes[`${HOBBY_NAME_FONT_SIZE}DeskRange`];
	const hobbyNameFontSizeUnit = attributes[`${HOBBY_NAME_FONT_SIZE}Unit`];
	// Hobby Icon Font Size
	const deskHobbyIconFontSize =
		attributes[`${HOBBY_ICON_FONT_SIZE}DeskRange`];
	const hobbyIconFontSizeUnit = attributes[`${HOBBY_ICON_FONT_SIZE}Unit`];
	// Hobby Item Gap
	const deskHobbyItemGap = attributes[`${HOBBY_ITEM_GAP}DeskRange`];
	const hobbyItemGapUnit = attributes[`${HOBBY_ITEM_GAP}Unit`];

	// Education Title Font Size
	const deskEducationTitleFontSize =
		attributes[`${EDUCATION_TITLE_FONT_SIZE}DeskRange`];
	const educationTitleFontSizeUnit =
		attributes[`${EDUCATION_TITLE_FONT_SIZE}Unit`];
	// Education Title Icon Font Size
	const deskEducationTitleIconFontSize =
		attributes[`${EDUCATION_TITLE_ICON_FONT_SIZE}DeskRange`];
	const educationTitleIconFontSizeUnit =
		attributes[`${EDUCATION_TITLE_ICON_FONT_SIZE}Unit`];
	// Education Name Font Size
	const deskStudyFieldFontSize =
		attributes[`${STUDY_FIELD_FONT_SIZE}DeskRange`];
	const studyFieldFontSizeUnit = attributes[`${STUDY_FIELD_FONT_SIZE}Unit`];
	// Education Degree Font Size
	const deskEducationDegreeNameFontSize =
		attributes[`${EDUCATION_DEGREE_NAME_FONT_SIZE}DeskRange`];
	const educationDegreeNameFontSizeUnit =
		attributes[`${EDUCATION_DEGREE_NAME_FONT_SIZE}Unit`];
	// Education Description Font Size
	const deskEducationDescriptionFontSize =
		attributes[`${EDUCATION_DESCRIPTION_FONT_SIZE}DeskRange`];
	const educationDescriptionFontSizeUnit =
		attributes[`${EDUCATION_DESCRIPTION_FONT_SIZE}Unit`];
	// Education Passing Year Font Size
	const deskEducationDateFontSize =
		attributes[`${EDUCATION_PASSING_YEAR_FONT_SIZE}DeskRange`];
	const educationDateFontSizeUnit =
		attributes[`${EDUCATION_PASSING_YEAR_FONT_SIZE}Unit`];
	// Education Institution Font Size
	const deskEducationInstitutionFontSize =
		attributes[`${INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE}DeskRange`];
	const educationInstitutionFontSizeUnit =
		attributes[`${INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE}Unit`];
	// Experience Title Font Size
	const deskExperienceTitleFontSize =
		attributes[`${EXPERIENCE_TITLE_FONT_SIZE}DeskRange`];
	const experienceTitleFontSizeUnit =
		attributes[`${EXPERIENCE_TITLE_FONT_SIZE}Unit`];
	// Experience Title Icon Font Size
	const deskExperienceTitleIconFontSize =
		attributes[`${EXPERIENCE_TITLE_ICON_FONT_SIZE}DeskRange`];
	const experienceTitleIconFontSizeUnit =
		attributes[`${EXPERIENCE_TITLE_ICON_FONT_SIZE}Unit`];
	// Experience Company Font Size
	const deskExperienceCompanyFontSize =
		attributes[`${EXPERIENCE_COMPANY_FONT_SIZE}DeskRange`];
	const experienceCompanyFontSizeUnit =
		attributes[`${EXPERIENCE_COMPANY_FONT_SIZE}Unit`];
	// Experience Designation Font Size
	const deskExperienceDesignationFontSize =
		attributes[`${EXPERIENCE_DESIGNATION_FONT_SIZE}DeskRange`];
	const experienceDesignationFontSizeUnit =
		attributes[`${EXPERIENCE_DESIGNATION_FONT_SIZE}Unit`];
	// Experience Description Font Size
	const deskExperienceDescriptionFontSize =
		attributes[`${EXPERIENCE_DESCRIPTION_FONT_SIZE}DeskRange`];
	const experienceDescriptionFontSizeUnit =
		attributes[`${EXPERIENCE_DESCRIPTION_FONT_SIZE}Unit`];
	// Experience Date Font Size
	const deskExperienceDateFontSize =
		attributes[`${EXPERIENCE_DATE_FONT_SIZE}DeskRange`];
	const experienceDateFontSizeUnit =
		attributes[`${EXPERIENCE_DATE_FONT_SIZE}Unit`];
	// Reference Title Font Size
	const deskReferenceTitleFontSize =
		attributes[`${REFERENCE_TITLE_FONT_SIZE}DeskRange`];
	const referenceTitleFontSizeUnit =
		attributes[`${REFERENCE_TITLE_FONT_SIZE}Unit`];
	// Reference Title Icon Font Size
	const deskReferenceTitleIconFontSize =
		attributes[`${REFERENCE_TITLE_ICON_FONT_SIZE}DeskRange`];
	const referenceTitleIconFontSizeUnit =
		attributes[`${REFERENCE_TITLE_ICON_FONT_SIZE}Unit`];
	// Reference Name Font Size
	const deskReferenceNameFontSize =
		attributes[`${REFERENCE_NAME_FONT_SIZE}DeskRange`];
	const referenceNameFontSizeUnit =
		attributes[`${REFERENCE_NAME_FONT_SIZE}Unit`];
	// Reference Job Position Font Size
	const deskReferenceJobPositionFontSize =
		attributes[`${REFERENCE_JOB_POSITION_FONT_SIZE}DeskRange`];
	const referenceJobPositionFontSizeUnit =
		attributes[`${REFERENCE_JOB_POSITION_FONT_SIZE}Unit`];
	// Reference Company Font Size
	const deskReferenceCompanyFontSize =
		attributes[`${REFERENCE_COMPANY_FONT_SIZE}DeskRange`];
	const referenceCompanyFontSizeUnit =
		attributes[`${REFERENCE_COMPANY_FONT_SIZE}Unit`];
	// Reference Phone Font Size
	const deskReferencePhoneFontSize =
		attributes[`${REFERENCE_PHONE_FONT_SIZE}DeskRange`];
	const referencePhoneFontSizeUnit =
		attributes[`${REFERENCE_PHONE_FONT_SIZE}Unit`];
	// Reference Relation Font Size
	const deskReferenceRelationFontSize =
		attributes[`${REFERENCE_RELATION_FONT_SIZE}DeskRange`];
	const referenceRelationFontSizeUnit =
		attributes[`${REFERENCE_RELATION_FONT_SIZE}Unit`];
	// About Title Padding
	const deskAboutPaddingTop = attributes[`${ABOUT_PADDING_TOP}DeskRange`];
	const aboutPaddingTopUnit = attributes[`${ABOUT_PADDING_TOP}Unit`];
	const deskAboutPaddingRight = attributes[`${ABOUT_PADDING_RIGHT}DeskRange`];
	const aboutPaddingRightUnit = attributes[`${ABOUT_PADDING_RIGHT}Unit`];
	const deskAboutPaddingBottom =
		attributes[`${ABOUT_PADDING_BOTTOM}DeskRange`];
	const aboutPaddingBottomUnit = attributes[`${ABOUT_PADDING_BOTTOM}Unit`];
	const deskAboutPaddingLeft = attributes[`${ABOUT_PADDING_LEFT}DeskRange`];
	const aboutPaddingLeftUnit = attributes[`${ABOUT_PADDING_LEFT}Unit`];
	// About Title Border Radius
	const deskAboutBorderRadiusTop =
		attributes[`${ABOUT_BORDER_RADIUS_TOP}DeskRange`];
	const aboutBorderRadiusTopUnit =
		attributes[`${ABOUT_BORDER_RADIUS_TOP}Unit`];
	const deskAboutBorderRadiusRight =
		attributes[`${ABOUT_BORDER_RADIUS_RIGHT}DeskRange`];
	const aboutBorderRadiusRightUnit =
		attributes[`${ABOUT_BORDER_RADIUS_RIGHT}Unit`];
	const deskAboutBorderRadiusBottom =
		attributes[`${ABOUT_BORDER_RADIUS_BOTTOM}DeskRange`];
	const aboutBorderRadiusBottomUnit =
		attributes[`${ABOUT_BORDER_RADIUS_BOTTOM}Unit`];
	const deskAboutBorderRadiusLeft =
		attributes[`${ABOUT_BORDER_RADIUS_LEFT}DeskRange`];
	const aboutBorderRadiusLeftUnit =
		attributes[`${ABOUT_BORDER_RADIUS_LEFT}Unit`];
	// Contact Title Padding
	const deskContactPaddingTop = attributes[`${CONTACT_PADDING_TOP}DeskRange`];
	const contactPaddingTopUnit = attributes[`${CONTACT_PADDING_TOP}Unit`];
	const deskContactPaddingRight =
		attributes[`${CONTACT_PADDING_RIGHT}DeskRange`];
	const contactPaddingRightUnit = attributes[`${CONTACT_PADDING_RIGHT}Unit`];
	const deskContactPaddingBottom =
		attributes[`${CONTACT_PADDING_BOTTOM}DeskRange`];
	const contactPaddingBottomUnit =
		attributes[`${CONTACT_PADDING_BOTTOM}Unit`];
	const deskContactPaddingLeft =
		attributes[`${CONTACT_PADDING_LEFT}DeskRange`];
	const contactPaddingLeftUnit = attributes[`${CONTACT_PADDING_LEFT}Unit`];
	// Contact Title Border Radius
	const deskContactBorderRadiusTop =
		attributes[`${CONTACT_BORDER_RADIUS_TOP}DeskRange`];
	const contactBorderRadiusTopUnit =
		attributes[`${CONTACT_BORDER_RADIUS_TOP}Unit`];
	const deskContactBorderRadiusRight =
		attributes[`${CONTACT_BORDER_RADIUS_RIGHT}DeskRange`];
	const contactBorderRadiusRightUnit =
		attributes[`${CONTACT_BORDER_RADIUS_RIGHT}Unit`];
	const deskContactBorderRadiusBottom =
		attributes[`${CONTACT_BORDER_RADIUS_BOTTOM}DeskRange`];
	const contactBorderRadiusBottomUnit =
		attributes[`${CONTACT_BORDER_RADIUS_BOTTOM}Unit`];
	const deskContactBorderRadiusLeft =
		attributes[`${CONTACT_BORDER_RADIUS_LEFT}DeskRange`];
	const contactBorderRadiusLeftUnit =
		attributes[`${CONTACT_BORDER_RADIUS_LEFT}Unit`];
	// Skill Title Padding
	const deskSkillPaddingTop = attributes[`${SKILL_PADDING_TOP}DeskRange`];
	const skillPaddingTopUnit = attributes[`${SKILL_PADDING_TOP}Unit`];
	const deskSkillPaddingRight = attributes[`${SKILL_PADDING_RIGHT}DeskRange`];
	const skillPaddingRightUnit = attributes[`${SKILL_PADDING_RIGHT}Unit`];
	const deskSkillPaddingBottom =
		attributes[`${SKILL_PADDING_BOTTOM}DeskRange`];
	const skillPaddingBottomUnit = attributes[`${SKILL_PADDING_BOTTOM}Unit`];
	const deskSkillPaddingLeft = attributes[`${SKILL_PADDING_LEFT}DeskRange`];
	const skillPaddingLeftUnit = attributes[`${SKILL_PADDING_LEFT}Unit`];
	// Skill Title Border Radius
	const deskSkillBorderRadiusTop =
		attributes[`${SKILL_BORDER_RADIUS_TOP}DeskRange`];
	const skillBorderRadiusTopUnit =
		attributes[`${SKILL_BORDER_RADIUS_TOP}Unit`];
	const deskSkillBorderRadiusRight =
		attributes[`${SKILL_BORDER_RADIUS_RIGHT}DeskRange`];
	const skillBorderRadiusRightUnit =
		attributes[`${SKILL_BORDER_RADIUS_RIGHT}Unit`];
	const deskSkillBorderRadiusBottom =
		attributes[`${SKILL_BORDER_RADIUS_BOTTOM}DeskRange`];
	const skillBorderRadiusBottomUnit =
		attributes[`${SKILL_BORDER_RADIUS_BOTTOM}Unit`];
	const deskSkillBorderRadiusLeft =
		attributes[`${SKILL_BORDER_RADIUS_LEFT}DeskRange`];
	const skillBorderRadiusLeftUnit =
		attributes[`${SKILL_BORDER_RADIUS_LEFT}Unit`];
	// Language Title Padding
	const deskLanguagePaddingTop =
		attributes[`${LANGUAGE_PADDING_TOP}DeskRange`];
	const languagePaddingTopUnit = attributes[`${LANGUAGE_PADDING_TOP}Unit`];
	const deskLanguagePaddingRight =
		attributes[`${LANGUAGE_PADDING_RIGHT}DeskRange`];
	const languagePaddingRightUnit =
		attributes[`${LANGUAGE_PADDING_RIGHT}Unit`];
	const deskLanguagePaddingBottom =
		attributes[`${LANGUAGE_PADDING_BOTTOM}DeskRange`];
	const languagePaddingBottomUnit =
		attributes[`${LANGUAGE_PADDING_BOTTOM}Unit`];
	const deskLanguagePaddingLeft =
		attributes[`${LANGUAGE_PADDING_LEFT}DeskRange`];
	const languagePaddingLeftUnit = attributes[`${LANGUAGE_PADDING_LEFT}Unit`];
	// Language Title Border Radius
	const deskLanguageBorderRadiusTop =
		attributes[`${LANGUAGE_BORDER_RADIUS_TOP}DeskRange`];
	const languageBorderRadiusTopUnit =
		attributes[`${LANGUAGE_BORDER_RADIUS_TOP}Unit`];
	const deskLanguageBorderRadiusRight =
		attributes[`${LANGUAGE_BORDER_RADIUS_RIGHT}DeskRange`];
	const languageBorderRadiusRightUnit =
		attributes[`${LANGUAGE_BORDER_RADIUS_RIGHT}Unit`];
	const deskLanguageBorderRadiusBottom =
		attributes[`${LANGUAGE_BORDER_RADIUS_BOTTOM}DeskRange`];
	const languageBorderRadiusBottomUnit =
		attributes[`${LANGUAGE_BORDER_RADIUS_BOTTOM}Unit`];
	const deskLanguageBorderRadiusLeft =
		attributes[`${LANGUAGE_BORDER_RADIUS_LEFT}DeskRange`];
	const languageBorderRadiusLeftUnit =
		attributes[`${LANGUAGE_BORDER_RADIUS_LEFT}Unit`];
	// Hobby Title Padding
	const deskHobbyPaddingTop = attributes[`${HOBBY_PADDING_TOP}DeskRange`];
	const hobbyPaddingTopUnit = attributes[`${HOBBY_PADDING_TOP}Unit`];
	const deskHobbyPaddingRight = attributes[`${HOBBY_PADDING_RIGHT}DeskRange`];
	const hobbyPaddingRightUnit = attributes[`${HOBBY_PADDING_RIGHT}Unit`];
	const deskHobbyPaddingBottom =
		attributes[`${HOBBY_PADDING_BOTTOM}DeskRange`];
	const hobbyPaddingBottomUnit = attributes[`${HOBBY_PADDING_BOTTOM}Unit`];
	const deskHobbyPaddingLeft = attributes[`${HOBBY_PADDING_LEFT}DeskRange`];
	const hobbyPaddingLeftUnit = attributes[`${HOBBY_PADDING_LEFT}Unit`];
	// Hobby Title Border Radius
	const deskHobbyBorderRadiusTop =
		attributes[`${HOBBY_BORDER_RADIUS_TOP}DeskRange`];
	const hobbyBorderRadiusTopUnit =
		attributes[`${HOBBY_BORDER_RADIUS_TOP}Unit`];
	const deskHobbyBorderRadiusRight =
		attributes[`${HOBBY_BORDER_RADIUS_RIGHT}DeskRange`];
	const hobbyBorderRadiusRightUnit =
		attributes[`${HOBBY_BORDER_RADIUS_RIGHT}Unit`];
	const deskHobbyBorderRadiusBottom =
		attributes[`${HOBBY_BORDER_RADIUS_BOTTOM}DeskRange`];
	const hobbyBorderRadiusBottomUnit =
		attributes[`${HOBBY_BORDER_RADIUS_BOTTOM}Unit`];
	const deskHobbyBorderRadiusLeft =
		attributes[`${HOBBY_BORDER_RADIUS_LEFT}DeskRange`];
	const hobbyBorderRadiusLeftUnit =
		attributes[`${HOBBY_BORDER_RADIUS_LEFT}Unit`];
	// Education Title Padding
	const deskEducationPaddingTop =
		attributes[`${EDUCATION_PADDING_TOP}DeskRange`];
	const educationPaddingTopUnit = attributes[`${EDUCATION_PADDING_TOP}Unit`];
	const deskEducationPaddingRight =
		attributes[`${EDUCATION_PADDING_RIGHT}DeskRange`];
	const educationPaddingRightUnit =
		attributes[`${EDUCATION_PADDING_RIGHT}Unit`];
	const deskEducationPaddingBottom =
		attributes[`${EDUCATION_PADDING_BOTTOM}DeskRange`];
	const educationPaddingBottomUnit =
		attributes[`${EDUCATION_PADDING_BOTTOM}Unit`];
	const deskEducationPaddingLeft =
		attributes[`${EDUCATION_PADDING_LEFT}DeskRange`];
	const educationPaddingLeftUnit =
		attributes[`${EDUCATION_PADDING_LEFT}Unit`];
	// Education Title Border Radius
	const deskEducationBorderRadiusTop =
		attributes[`${EDUCATION_BORDER_RADIUS_TOP}DeskRange`];
	const educationBorderRadiusTopUnit =
		attributes[`${EDUCATION_BORDER_RADIUS_TOP}Unit`];
	const deskEducationBorderRadiusRight =
		attributes[`${EDUCATION_BORDER_RADIUS_RIGHT}DeskRange`];
	const educationBorderRadiusRightUnit =
		attributes[`${EDUCATION_BORDER_RADIUS_RIGHT}Unit`];
	const deskEducationBorderRadiusBottom =
		attributes[`${EDUCATION_BORDER_RADIUS_BOTTOM}DeskRange`];
	const educationBorderRadiusBottomUnit =
		attributes[`${EDUCATION_BORDER_RADIUS_BOTTOM}Unit`];
	const deskEducationBorderRadiusLeft =
		attributes[`${EDUCATION_BORDER_RADIUS_LEFT}DeskRange`];
	const educationBorderRadiusLeftUnit =
		attributes[`${EDUCATION_BORDER_RADIUS_LEFT}Unit`];
	// Experience Title Padding
	const deskExperiencePaddingTop =
		attributes[`${EXPERIENCE_PADDING_TOP}DeskRange`];
	const experiencePaddingTopUnit =
		attributes[`${EXPERIENCE_PADDING_TOP}Unit`];
	const deskExperiencePaddingRight =
		attributes[`${EXPERIENCE_PADDING_RIGHT}DeskRange`];
	const experiencePaddingRightUnit =
		attributes[`${EXPERIENCE_PADDING_RIGHT}Unit`];
	const deskExperiencePaddingBottom =
		attributes[`${EXPERIENCE_PADDING_BOTTOM}DeskRange`];
	const experiencePaddingBottomUnit =
		attributes[`${EXPERIENCE_PADDING_BOTTOM}Unit`];
	const deskExperiencePaddingLeft =
		attributes[`${EXPERIENCE_PADDING_LEFT}DeskRange`];
	const experiencePaddingLeftUnit =
		attributes[`${EXPERIENCE_PADDING_LEFT}Unit`];
	// Experience Title Border Radius
	const deskExperienceBorderRadiusTop =
		attributes[`${EXPERIENCE_BORDER_RADIUS_TOP}DeskRange`];
	const experienceBorderRadiusTopUnit =
		attributes[`${EXPERIENCE_BORDER_RADIUS_TOP}Unit`];
	const deskExperienceBorderRadiusRight =
		attributes[`${EXPERIENCE_BORDER_RADIUS_RIGHT}DeskRange`];
	const experienceBorderRadiusRightUnit =
		attributes[`${EXPERIENCE_BORDER_RADIUS_RIGHT}Unit`];
	const deskExperienceBorderRadiusBottom =
		attributes[`${EXPERIENCE_BORDER_RADIUS_BOTTOM}DeskRange`];
	const experienceBorderRadiusBottomUnit =
		attributes[`${EXPERIENCE_BORDER_RADIUS_BOTTOM}Unit`];
	const deskExperienceBorderRadiusLeft =
		attributes[`${EXPERIENCE_BORDER_RADIUS_LEFT}DeskRange`];
	const experienceBorderRadiusLeftUnit =
		attributes[`${EXPERIENCE_BORDER_RADIUS_LEFT}Unit`];
	// Reference Title Padding
	const deskReferencePaddingTop =
		attributes[`${REFERENCE_PADDING_TOP}DeskRange`];
	const referencePaddingTopUnit = attributes[`${REFERENCE_PADDING_TOP}Unit`];
	const deskReferencePaddingRight =
		attributes[`${REFERENCE_PADDING_RIGHT}DeskRange`];
	const referencePaddingRightUnit =
		attributes[`${REFERENCE_PADDING_RIGHT}Unit`];
	const deskReferencePaddingBottom =
		attributes[`${REFERENCE_PADDING_BOTTOM}DeskRange`];
	const referencePaddingBottomUnit =
		attributes[`${REFERENCE_PADDING_BOTTOM}Unit`];
	const deskReferencePaddingLeft =
		attributes[`${REFERENCE_PADDING_LEFT}DeskRange`];
	const referencePaddingLeftUnit =
		attributes[`${REFERENCE_PADDING_LEFT}Unit`];
	// Reference Title Border Radius
	const deskReferenceBorderRadiusTop =
		attributes[`${REFERENCE_BORDER_RADIUS_TOP}DeskRange`];
	const referenceBorderRadiusTopUnit =
		attributes[`${REFERENCE_BORDER_RADIUS_TOP}Unit`];
	const deskReferenceBorderRadiusRight =
		attributes[`${REFERENCE_BORDER_RADIUS_RIGHT}DeskRange`];
	const referenceBorderRadiusRightUnit =
		attributes[`${REFERENCE_BORDER_RADIUS_RIGHT}Unit`];
	const deskReferenceBorderRadiusBottom =
		attributes[`${REFERENCE_BORDER_RADIUS_BOTTOM}DeskRange`];
	const referenceBorderRadiusBottomUnit =
		attributes[`${REFERENCE_BORDER_RADIUS_BOTTOM}Unit`];
	const deskReferenceBorderRadiusLeft =
		attributes[`${REFERENCE_BORDER_RADIUS_LEFT}DeskRange`];
	const referenceBorderRadiusLeftUnit =
		attributes[`${REFERENCE_BORDER_RADIUS_LEFT}Unit`];

	// About Section Padding
	const deskAboutSectionPaddingTop =
		attributes[`${ABOUT_SECTION_PADDING_TOP}DeskRange`];
	const aboutSectionPaddingTopUnit =
		attributes[`${ABOUT_SECTION_PADDING_TOP}Unit`];
	const deskAboutSectionPaddingRight =
		attributes[`${ABOUT_SECTION_PADDING_RIGHT}DeskRange`];
	const aboutSectionPaddingRightUnit =
		attributes[`${ABOUT_SECTION_PADDING_RIGHT}Unit`];
	const deskAboutSectionPaddingBottom =
		attributes[`${ABOUT_SECTION_PADDING_BOTTOM}DeskRange`];
	const aboutSectionPaddingBottomUnit =
		attributes[`${ABOUT_SECTION_PADDING_BOTTOM}Unit`];
	const deskAboutSectionPaddingLeft =
		attributes[`${ABOUT_SECTION_PADDING_LEFT}DeskRange`];
	const aboutSectionPaddingLeftUnit =
		attributes[`${ABOUT_SECTION_PADDING_LEFT}Unit`];

	// Contact Section Padding
	const deskContactSectionPaddingTop =
		attributes[`${CONTACT_SECTION_PADDING_TOP}DeskRange`];
	const contactSectionPaddingTopUnit =
		attributes[`${CONTACT_SECTION_PADDING_TOP}Unit`];
	const deskContactSectionPaddingRight =
		attributes[`${CONTACT_SECTION_PADDING_RIGHT}DeskRange`];
	const contactSectionPaddingRightUnit =
		attributes[`${CONTACT_SECTION_PADDING_RIGHT}Unit`];
	const deskContactSectionPaddingBottom =
		attributes[`${CONTACT_SECTION_PADDING_BOTTOM}DeskRange`];
	const contactSectionPaddingBottomUnit =
		attributes[`${CONTACT_SECTION_PADDING_BOTTOM}Unit`];
	const deskContactSectionPaddingLeft =
		attributes[`${CONTACT_SECTION_PADDING_LEFT}DeskRange`];
	const contactSectionPaddingLeftUnit =
		attributes[`${CONTACT_SECTION_PADDING_LEFT}Unit`];

	// Skill Section Padding
	const deskSkillSectionPaddingTop =
		attributes[`${SKILL_SECTION_PADDING_TOP}DeskRange`];
	const skillSectionPaddingTopUnit =
		attributes[`${SKILL_SECTION_PADDING_TOP}Unit`];
	const deskSkillSectionPaddingRight =
		attributes[`${SKILL_SECTION_PADDING_RIGHT}DeskRange`];
	const skillSectionPaddingRightUnit =
		attributes[`${SKILL_SECTION_PADDING_RIGHT}Unit`];
	const deskSkillSectionPaddingBottom =
		attributes[`${SKILL_SECTION_PADDING_BOTTOM}DeskRange`];
	const skillSectionPaddingBottomUnit =
		attributes[`${SKILL_SECTION_PADDING_BOTTOM}Unit`];
	const deskSkillSectionPaddingLeft =
		attributes[`${SKILL_SECTION_PADDING_LEFT}DeskRange`];
	const skillSectionPaddingLeftUnit =
		attributes[`${SKILL_SECTION_PADDING_LEFT}Unit`];
	// Language Section Padding
	const deskLanguageSectionPaddingTop =
		attributes[`${LANGUAGE_SECTION_PADDING_TOP}DeskRange`];
	const deskLanguageSectionPaddingRight =
		attributes[`${LANGUAGE_SECTION_PADDING_RIGHT}DeskRange`];
	const deskLanguageSectionPaddingBottom =
		attributes[`${LANGUAGE_SECTION_PADDING_BOTTOM}DeskRange`];
	const deskLanguageSectionPaddingLeft =
		attributes[`${LANGUAGE_SECTION_PADDING_LEFT}DeskRange`];
	const languageSectionPaddingUnit =
		attributes[`${LANGUAGE_SECTION_PADDING_TOP}Unit`];
	// Hobby Section Padding
	const deskHobbySectionPaddingTop =
		attributes[`${HOBBY_SECTION_PADDING_TOP}DeskRange`];
	const deskHobbySectionPaddingRight =
		attributes[`${HOBBY_SECTION_PADDING_RIGHT}DeskRange`];
	const deskHobbySectionPaddingBottom =
		attributes[`${HOBBY_SECTION_PADDING_BOTTOM}DeskRange`];
	const deskHobbySectionPaddingLeft =
		attributes[`${HOBBY_SECTION_PADDING_LEFT}DeskRange`];
	const hobbySectionPaddingUnit =
		attributes[`${HOBBY_SECTION_PADDING_TOP}Unit`];
	// Education Section Padding
	const deskEducationSectionPaddingTop =
		attributes[`${EDUCATION_SECTION_PADDING_TOP}DeskRange`];
	const deskEducationSectionPaddingRight =
		attributes[`${EDUCATION_SECTION_PADDING_RIGHT}DeskRange`];
	const deskEducationSectionPaddingBottom =
		attributes[`${EDUCATION_SECTION_PADDING_BOTTOM}DeskRange`];
	const deskEducationSectionPaddingLeft =
		attributes[`${EDUCATION_SECTION_PADDING_LEFT}DeskRange`];
	const educationSectionPaddingUnit =
		attributes[`${EDUCATION_SECTION_PADDING_TOP}Unit`];
	// Experience Section Padding
	const deskExperienceSectionPaddingTop =
		attributes[`${EXPERIENCE_SECTION_PADDING_TOP}DeskRange`];
	const deskExperienceSectionPaddingRight =
		attributes[`${EXPERIENCE_SECTION_PADDING_RIGHT}DeskRange`];
	const deskExperienceSectionPaddingBottom =
		attributes[`${EXPERIENCE_SECTION_PADDING_BOTTOM}DeskRange`];
	const deskExperienceSectionPaddingLeft =
		attributes[`${EXPERIENCE_SECTION_PADDING_LEFT}DeskRange`];
	const experienceSectionPaddingUnit =
		attributes[`${EXPERIENCE_SECTION_PADDING_TOP}Unit`];
	// Reference Section Padding
	const deskReferenceSectionPaddingTop =
		attributes[`${REFERENCE_SECTION_PADDING_TOP}DeskRange`];
	const deskReferenceSectionPaddingRight =
		attributes[`${REFERENCE_SECTION_PADDING_RIGHT}DeskRange`];
	const deskReferenceSectionPaddingBottom =
		attributes[`${REFERENCE_SECTION_PADDING_BOTTOM}DeskRange`];
	const deskReferenceSectionPaddingLeft =
		attributes[`${REFERENCE_SECTION_PADDING_LEFT}DeskRange`];
	const referenceSectionPaddingUnit =
		attributes[`${REFERENCE_SECTION_PADDING_TOP}Unit`];
	// Header Padding
	const deskHeaderPaddingTop = attributes[`${HEADER_PADDING_TOP}DeskRange`];
	const deskHeaderPaddingRight =
		attributes[`${HEADER_PADDING_RIGHT}DeskRange`];
	const deskHeaderPaddingBottom =
		attributes[`${HEADER_PADDING_BOTTOM}DeskRange`];
	const deskHeaderPaddingLeft = attributes[`${HEADER_PADDING_LEFT}DeskRange`];
	const headerPaddingUnit = attributes[`${HEADER_PADDING_TOP}Unit`];
	// Footer Padding
	const deskFooterPaddingTop = attributes[`${FOOTER_PADDING_TOP}DeskRange`];
	const deskFooterPaddingRight =
		attributes[`${FOOTER_PADDING_RIGHT}DeskRange`];
	const deskFooterPaddingBottom =
		attributes[`${FOOTER_PADDING_BOTTOM}DeskRange`];
	const deskFooterPaddingLeft = attributes[`${FOOTER_PADDING_LEFT}DeskRange`];
	const footerPaddingUnit = attributes[`${FOOTER_PADDING_TOP}Unit`];
	// Skill Bar Gap
	const deskSkillBarGap = attributes[`${SKILL_BAR_GAP}DeskRange`];
	const skillBarGapUnit = attributes[`${SKILL_BAR_GAP}Unit`];
	// Language Bar Gap
	const deskLanguageBarGap = attributes[`${LANGUAGE_BAR_GAP}DeskRange`];
	const languageBarGapUnit = attributes[`${LANGUAGE_BAR_GAP}Unit`];	

	// Desk About Padding and Border Radius
	const deskAboutPaddingStyles = {
		...(deskAboutPaddingTop !== undefined &&
			deskAboutPaddingTop !== '' && {
				paddingTop: `${deskAboutPaddingTop}${aboutPaddingTopUnit}`,
			}),
		...(deskAboutPaddingRight !== undefined &&
			deskAboutPaddingRight !== '' && {
				paddingRight: `${deskAboutPaddingRight}${aboutPaddingRightUnit}`,
			}),
		...(deskAboutPaddingBottom !== undefined &&
			deskAboutPaddingBottom !== '' && {
				paddingBottom: `${deskAboutPaddingBottom}${aboutPaddingBottomUnit}`,
			}),
		...(deskAboutPaddingLeft !== undefined &&
			deskAboutPaddingLeft !== '' && {
				paddingLeft: `${deskAboutPaddingLeft}${aboutPaddingLeftUnit}`,
			}),
		...(deskAboutBorderRadiusTop !== undefined &&
			deskAboutBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskAboutBorderRadiusTop}${aboutBorderRadiusTopUnit}`,
			}),
		...(deskAboutBorderRadiusRight !== undefined &&
			deskAboutBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskAboutBorderRadiusRight}${aboutBorderRadiusRightUnit}`,
			}),
		...(deskAboutBorderRadiusBottom !== undefined &&
			deskAboutBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskAboutBorderRadiusBottom}${aboutBorderRadiusBottomUnit}`,
			}),
		...(deskAboutBorderRadiusLeft !== undefined &&
			deskAboutBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskAboutBorderRadiusLeft}${aboutBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Contact Padding and Border Radius
	const deskContactPaddingStyles = {
		...(deskContactPaddingTop !== undefined &&
			deskContactPaddingTop !== '' && {
				paddingTop: `${deskContactPaddingTop}${contactPaddingTopUnit}`,
			}),
		...(deskContactPaddingRight !== undefined &&
			deskContactPaddingRight !== '' && {
				paddingRight: `${deskContactPaddingRight}${contactPaddingRightUnit}`,
			}),
		...(deskContactPaddingBottom !== undefined &&
			deskContactPaddingBottom !== '' && {
				paddingBottom: `${deskContactPaddingBottom}${contactPaddingBottomUnit}`,
			}),
		...(deskContactPaddingLeft !== undefined &&
			deskContactPaddingLeft !== '' && {
				paddingLeft: `${deskContactPaddingLeft}${contactPaddingLeftUnit}`,
			}),
		...(deskContactBorderRadiusTop !== undefined &&
			deskContactBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskContactBorderRadiusTop}${contactBorderRadiusTopUnit}`,
			}),
		...(deskContactBorderRadiusRight !== undefined &&
			deskContactBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskContactBorderRadiusRight}${contactBorderRadiusRightUnit}`,
			}),
		...(deskContactBorderRadiusBottom !== undefined &&
			deskContactBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskContactBorderRadiusBottom}${contactBorderRadiusBottomUnit}`,
			}),
		...(deskContactBorderRadiusLeft !== undefined &&
			deskContactBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskContactBorderRadiusLeft}${contactBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Skill Padding and Border Radius
	const deskSkillPaddingStyles = {
		...(deskSkillPaddingTop !== undefined &&
			deskSkillPaddingTop !== '' && {
				paddingTop: `${deskSkillPaddingTop}${skillPaddingTopUnit}`,
			}),
		...(deskSkillPaddingRight !== undefined &&
			deskSkillPaddingRight !== '' && {
				paddingRight: `${deskSkillPaddingRight}${skillPaddingRightUnit}`,
			}),
		...(deskSkillPaddingBottom !== undefined &&
			deskSkillPaddingBottom !== '' && {
				paddingBottom: `${deskSkillPaddingBottom}${skillPaddingBottomUnit}`,
			}),
		...(deskSkillPaddingLeft !== undefined &&
			deskSkillPaddingLeft !== '' && {
				paddingLeft: `${deskSkillPaddingLeft}${skillPaddingLeftUnit}`,
			}),
		...(deskSkillBorderRadiusTop !== undefined &&
			deskSkillBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskSkillBorderRadiusTop}${skillBorderRadiusTopUnit}`,
			}),
		...(deskSkillBorderRadiusRight !== undefined &&
			deskSkillBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskSkillBorderRadiusRight}${skillBorderRadiusRightUnit}`,
			}),
		...(deskSkillBorderRadiusBottom !== undefined &&
			deskSkillBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskSkillBorderRadiusBottom}${skillBorderRadiusBottomUnit}`,
			}),
		...(deskSkillBorderRadiusLeft !== undefined &&
			deskSkillBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskSkillBorderRadiusLeft}${skillBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Language Padding and Border Radius
	const deskLanguagePaddingStyles = {
		...(deskLanguagePaddingTop !== undefined &&
			deskLanguagePaddingTop !== '' && {
				paddingTop: `${deskLanguagePaddingTop}${languagePaddingTopUnit}`,
			}),
		...(deskLanguagePaddingRight !== undefined &&
			deskLanguagePaddingRight !== '' && {
				paddingRight: `${deskLanguagePaddingRight}${languagePaddingRightUnit}`,
			}),
		...(deskLanguagePaddingBottom !== undefined &&
			deskLanguagePaddingBottom !== '' && {
				paddingBottom: `${deskLanguagePaddingBottom}${languagePaddingBottomUnit}`,
			}),
		...(deskLanguagePaddingLeft !== undefined &&
			deskLanguagePaddingLeft !== '' && {
				paddingLeft: `${deskLanguagePaddingLeft}${languagePaddingLeftUnit}`,
			}),
		...(deskLanguageBorderRadiusTop !== undefined &&
			deskLanguageBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskLanguageBorderRadiusTop}${languageBorderRadiusTopUnit}`,
			}),
		...(deskLanguageBorderRadiusRight !== undefined &&
			deskLanguageBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskLanguageBorderRadiusRight}${languageBorderRadiusRightUnit}`,
			}),
		...(deskLanguageBorderRadiusBottom !== undefined &&
			deskLanguageBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskLanguageBorderRadiusBottom}${languageBorderRadiusBottomUnit}`,
			}),
		...(deskLanguageBorderRadiusLeft !== undefined &&
			deskLanguageBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskLanguageBorderRadiusLeft}${languageBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Hobby Padding and Border Radius
	const deskHobbyPaddingStyles = {
		...(deskHobbyPaddingTop !== undefined &&
			deskHobbyPaddingTop !== '' && {
				paddingTop: `${deskHobbyPaddingTop}${hobbyPaddingTopUnit}`,
			}),
		...(deskHobbyPaddingRight !== undefined &&
			deskHobbyPaddingRight !== '' && {
				paddingRight: `${deskHobbyPaddingRight}${hobbyPaddingRightUnit}`,
			}),
		...(deskHobbyPaddingBottom !== undefined &&
			deskHobbyPaddingBottom !== '' && {
				paddingBottom: `${deskHobbyPaddingBottom}${hobbyPaddingBottomUnit}`,
			}),
		...(deskHobbyPaddingLeft !== undefined &&
			deskHobbyPaddingLeft !== '' && {
				paddingLeft: `${deskHobbyPaddingLeft}${hobbyPaddingLeftUnit}`,
			}),
		...(deskHobbyBorderRadiusTop !== undefined &&
			deskHobbyBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskHobbyBorderRadiusTop}${hobbyBorderRadiusTopUnit}`,
			}),
		...(deskHobbyBorderRadiusRight !== undefined &&
			deskHobbyBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskHobbyBorderRadiusRight}${hobbyBorderRadiusRightUnit}`,
			}),
		...(deskHobbyBorderRadiusBottom !== undefined &&
			deskHobbyBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskHobbyBorderRadiusBottom}${hobbyBorderRadiusBottomUnit}`,
			}),
		...(deskHobbyBorderRadiusLeft !== undefined &&
			deskHobbyBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskHobbyBorderRadiusLeft}${hobbyBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Education Padding and Border Radius
	const deskEducationPaddingStyles = {
		...(deskEducationPaddingTop !== undefined &&
			deskEducationPaddingTop !== '' && {
				paddingTop: `${deskEducationPaddingTop}${educationPaddingTopUnit}`,
			}),
		...(deskEducationPaddingRight !== undefined &&
			deskEducationPaddingRight !== '' && {
				paddingRight: `${deskEducationPaddingRight}${educationPaddingRightUnit}`,
			}),
		...(deskEducationPaddingBottom !== undefined &&
			deskEducationPaddingBottom !== '' && {
				paddingBottom: `${deskEducationPaddingBottom}${educationPaddingBottomUnit}`,
			}),
		...(deskEducationPaddingLeft !== undefined &&
			deskEducationPaddingLeft !== '' && {
				paddingLeft: `${deskEducationPaddingLeft}${educationPaddingLeftUnit}`,
			}),
		...(deskEducationBorderRadiusTop !== undefined &&
			deskEducationBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskEducationBorderRadiusTop}${educationBorderRadiusTopUnit}`,
			}),
		...(deskEducationBorderRadiusRight !== undefined &&
			deskEducationBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskEducationBorderRadiusRight}${educationBorderRadiusRightUnit}`,
			}),
		...(deskEducationBorderRadiusBottom !== undefined &&
			deskEducationBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskEducationBorderRadiusBottom}${educationBorderRadiusBottomUnit}`,
			}),
		...(deskEducationBorderRadiusLeft !== undefined &&
			deskEducationBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskEducationBorderRadiusLeft}${educationBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Experience Padding and Border Radius
	const deskExperiencePaddingStyles = {
		...(deskExperiencePaddingTop !== undefined &&
			deskExperiencePaddingTop !== '' && {
				paddingTop: `${deskExperiencePaddingTop}${experiencePaddingTopUnit}`,
			}),
		...(deskExperiencePaddingRight !== undefined &&
			deskExperiencePaddingRight !== '' && {
				paddingRight: `${deskExperiencePaddingRight}${experiencePaddingRightUnit}`,
			}),
		...(deskExperiencePaddingBottom !== undefined &&
			deskExperiencePaddingBottom !== '' && {
				paddingBottom: `${deskExperiencePaddingBottom}${experiencePaddingBottomUnit}`,
			}),
		...(deskExperiencePaddingLeft !== undefined &&
			deskExperiencePaddingLeft !== '' && {
				paddingLeft: `${deskExperiencePaddingLeft}${experiencePaddingLeftUnit}`,
			}),
		...(deskExperienceBorderRadiusTop !== undefined &&
			deskExperienceBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskExperienceBorderRadiusTop}${experienceBorderRadiusTopUnit}`,
			}),
		...(deskExperienceBorderRadiusRight !== undefined &&
			deskExperienceBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskExperienceBorderRadiusRight}${experienceBorderRadiusRightUnit}`,
			}),
		...(deskExperienceBorderRadiusBottom !== undefined &&
			deskExperienceBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskExperienceBorderRadiusBottom}${experienceBorderRadiusBottomUnit}`,
			}),
		...(deskExperienceBorderRadiusLeft !== undefined &&
			deskExperienceBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskExperienceBorderRadiusLeft}${experienceBorderRadiusLeftUnit}`,
			}),
	};
	// Desk Reference Padding and Border Radius
	const deskReferencePaddingStyles = {
		...(deskReferencePaddingTop !== undefined &&
			deskReferencePaddingTop !== '' && {
				paddingTop: `${deskReferencePaddingTop}${referencePaddingTopUnit}`,
			}),
		...(deskReferencePaddingRight !== undefined &&
			deskReferencePaddingRight !== '' && {
				paddingRight: `${deskReferencePaddingRight}${referencePaddingRightUnit}`,
			}),
		...(deskReferencePaddingBottom !== undefined &&
			deskReferencePaddingBottom !== '' && {
				paddingBottom: `${deskReferencePaddingBottom}${referencePaddingBottomUnit}`,
			}),
		...(deskReferencePaddingLeft !== undefined &&
			deskReferencePaddingLeft !== '' && {
				paddingLeft: `${deskReferencePaddingLeft}${referencePaddingLeftUnit}`,
			}),
		...(deskReferenceBorderRadiusTop !== undefined &&
			deskReferenceBorderRadiusTop !== '' && {
				borderTopLeftRadius: `${deskReferenceBorderRadiusTop}${referenceBorderRadiusTopUnit}`,
			}),
		...(deskReferenceBorderRadiusRight !== undefined &&
			deskReferenceBorderRadiusRight !== '' && {
				borderTopRightRadius: `${deskReferenceBorderRadiusRight}${referenceBorderRadiusRightUnit}`,
			}),
		...(deskReferenceBorderRadiusBottom !== undefined &&
			deskReferenceBorderRadiusBottom !== '' && {
				borderBottomRightRadius: `${deskReferenceBorderRadiusBottom}${referenceBorderRadiusBottomUnit}`,
			}),
		...(deskReferenceBorderRadiusLeft !== undefined &&
			deskReferenceBorderRadiusLeft !== '' && {
				borderBottomLeftRadius: `${deskReferenceBorderRadiusLeft}${referenceBorderRadiusLeftUnit}`,
			}),
	};
	// Desk About Section Padding
	const deskAboutSectionPaddingStyles = {
		...(deskAboutSectionPaddingTop !== undefined &&
			deskAboutSectionPaddingTop !== '' && {
				paddingTop: `${deskAboutSectionPaddingTop}${aboutSectionPaddingTopUnit}`,
			}),
		...(deskAboutSectionPaddingRight !== undefined &&
			deskAboutSectionPaddingRight !== '' && {
				paddingRight: `${deskAboutSectionPaddingRight}${aboutSectionPaddingRightUnit}`,
			}),
		...(deskAboutSectionPaddingBottom !== undefined &&
			deskAboutSectionPaddingBottom !== '' && {
				paddingBottom: `${deskAboutSectionPaddingBottom}${aboutSectionPaddingBottomUnit}`,
			}),
		...(deskAboutSectionPaddingLeft !== undefined &&
			deskAboutSectionPaddingLeft !== '' && {
				paddingLeft: `${deskAboutSectionPaddingLeft}${aboutSectionPaddingLeftUnit}`,
			}),
	};

	// Contact Section Padding
	const deskContactSectionPaddingStyles = {
		...(deskContactSectionPaddingTop !== undefined &&
			deskContactSectionPaddingTop !== '' && {
				paddingTop: `${deskContactSectionPaddingTop}${contactSectionPaddingTopUnit}`,
			}),
		...(deskContactSectionPaddingRight !== undefined &&
			deskContactSectionPaddingRight !== '' && {
				paddingRight: `${deskContactSectionPaddingRight}${contactSectionPaddingRightUnit}`,
			}),
		...(deskContactSectionPaddingBottom !== undefined &&
			deskContactSectionPaddingBottom !== '' && {
				paddingBottom: `${deskContactSectionPaddingBottom}${contactSectionPaddingBottomUnit}`,
			}),
		...(deskContactSectionPaddingLeft !== undefined &&
			deskContactSectionPaddingLeft !== '' && {
				paddingLeft: `${deskContactSectionPaddingLeft}${contactSectionPaddingLeftUnit}`,
			}),
	};

	// Skill Section Padding
	const deskSkillSectionPaddingStyles = {
		...(deskSkillSectionPaddingTop !== undefined &&
			deskSkillSectionPaddingTop !== '' && {
				paddingTop: `${deskSkillSectionPaddingTop}${skillSectionPaddingTopUnit}`,
			}),
		...(deskSkillSectionPaddingRight !== undefined &&
			deskSkillSectionPaddingRight !== '' && {
				paddingRight: `${deskSkillSectionPaddingRight}${skillSectionPaddingRightUnit}`,
			}),
		...(deskSkillSectionPaddingBottom !== undefined &&
			deskSkillSectionPaddingBottom !== '' && {
				paddingBottom: `${deskSkillSectionPaddingBottom}${skillSectionPaddingBottomUnit}`,
			}),
		...(deskSkillSectionPaddingLeft !== undefined &&
			deskSkillSectionPaddingLeft !== '' && {
				paddingLeft: `${deskSkillSectionPaddingLeft}${skillSectionPaddingLeftUnit}`,
			}),
	};

	// Language Section Padding
	const deskLanguageSectionPaddingStyles = {
		...(deskLanguageSectionPaddingTop !== undefined &&
			deskLanguageSectionPaddingTop !== '' && {
				paddingTop: `${deskLanguageSectionPaddingTop}${languageSectionPaddingUnit}`,
			}),
		...(deskLanguageSectionPaddingRight !== undefined &&
			deskLanguageSectionPaddingRight !== '' && {
				paddingRight: `${deskLanguageSectionPaddingRight}${languageSectionPaddingUnit}`,
			}),
		...(deskLanguageSectionPaddingBottom !== undefined &&
			deskLanguageSectionPaddingBottom !== '' && {
				paddingBottom: `${deskLanguageSectionPaddingBottom}${languageSectionPaddingUnit}`,
			}),
		...(deskLanguageSectionPaddingLeft !== undefined &&
			deskLanguageSectionPaddingLeft !== '' && {
				paddingLeft: `${deskLanguageSectionPaddingLeft}${languageSectionPaddingUnit}`,
			}),
	};

	// Hobby Section Padding
	const deskHobbySectionPaddingStyles = {
		...(deskHobbySectionPaddingTop !== undefined &&
			deskHobbySectionPaddingTop !== '' && {
				paddingTop: `${deskHobbySectionPaddingTop}${hobbySectionPaddingUnit}`,
			}),
		...(deskHobbySectionPaddingRight !== undefined &&
			deskHobbySectionPaddingRight !== '' && {
				paddingRight: `${deskHobbySectionPaddingRight}${hobbySectionPaddingUnit}`,
			}),
		...(deskHobbySectionPaddingBottom !== undefined &&
			deskHobbySectionPaddingBottom !== '' && {
				paddingBottom: `${deskHobbySectionPaddingBottom}${hobbySectionPaddingUnit}`,
			}),
		...(deskHobbySectionPaddingLeft !== undefined &&
			deskHobbySectionPaddingLeft !== '' && {
				paddingLeft: `${deskHobbySectionPaddingLeft}${hobbySectionPaddingUnit}`,
			}),
	};

	// Education Section Padding
	const deskEducationSectionPaddingStyles = {
		...(deskEducationSectionPaddingTop !== undefined &&
			deskEducationSectionPaddingTop !== '' && {
				paddingTop: `${deskEducationSectionPaddingTop}${educationSectionPaddingUnit}`,
			}),
		...(deskEducationSectionPaddingRight !== undefined &&
			deskEducationSectionPaddingRight !== '' && {
				paddingRight: `${deskEducationSectionPaddingRight}${educationSectionPaddingUnit}`,
			}),
		...(deskEducationSectionPaddingBottom !== undefined &&
			deskEducationSectionPaddingBottom !== '' && {
				paddingBottom: `${deskEducationSectionPaddingBottom}${educationSectionPaddingUnit}`,
			}),
		...(deskEducationSectionPaddingLeft !== undefined &&
			deskEducationSectionPaddingLeft !== '' && {
				paddingLeft: `${deskEducationSectionPaddingLeft}${educationSectionPaddingUnit}`,
			}),
	};

	// Experience Section Padding
	const deskExperienceSectionPaddingStyles = {
		...(deskExperienceSectionPaddingTop !== undefined &&
			deskExperienceSectionPaddingTop !== '' && {
				paddingTop: `${deskExperienceSectionPaddingTop}${experienceSectionPaddingUnit}`,
			}),
		...(deskExperienceSectionPaddingRight !== undefined &&
			deskExperienceSectionPaddingRight !== '' && {
				paddingRight: `${deskExperienceSectionPaddingRight}${experienceSectionPaddingUnit}`,
			}),
		...(deskExperienceSectionPaddingBottom !== undefined &&
			deskExperienceSectionPaddingBottom !== '' && {
				paddingBottom: `${deskExperienceSectionPaddingBottom}${experienceSectionPaddingUnit}`,
			}),
		...(deskExperienceSectionPaddingLeft !== undefined &&
			deskExperienceSectionPaddingLeft !== '' && {
				paddingLeft: `${deskExperienceSectionPaddingLeft}${experienceSectionPaddingUnit}`,
			}),
	};
	// Reference Section Padding
	const deskReferenceSectionPaddingStyles = {
		...(deskReferenceSectionPaddingTop !== undefined &&
			deskReferenceSectionPaddingTop !== '' && {
				paddingTop: `${deskReferenceSectionPaddingTop}${referenceSectionPaddingUnit}`,
			}),
		...(deskReferenceSectionPaddingRight !== undefined &&
			deskReferenceSectionPaddingRight !== '' && {
				paddingRight: `${deskReferenceSectionPaddingRight}${referenceSectionPaddingUnit}`,
			}),
		...(deskReferenceSectionPaddingBottom !== undefined &&
			deskReferenceSectionPaddingBottom !== '' && {
				paddingBottom: `${deskReferenceSectionPaddingBottom}${referenceSectionPaddingUnit}`,
			}),
		...(deskReferenceSectionPaddingLeft !== undefined &&
			deskReferenceSectionPaddingLeft !== '' && {
				paddingLeft: `${deskReferenceSectionPaddingLeft}${referenceSectionPaddingUnit}`,
			}),
	};
	// Header Padding
	const deskHeaderPaddingStyles = {
		...(deskHeaderPaddingTop !== undefined &&
			deskHeaderPaddingTop !== '' && {
				paddingTop: `${deskHeaderPaddingTop}${headerPaddingUnit}`,
			}),
		...(deskHeaderPaddingRight !== undefined &&
			deskHeaderPaddingRight !== '' && {
				paddingRight: `${deskHeaderPaddingRight}${headerPaddingUnit}`,
			}),
		...(deskHeaderPaddingBottom !== undefined &&
			deskHeaderPaddingBottom !== '' && {
				paddingBottom: `${deskHeaderPaddingBottom}${headerPaddingUnit}`,
			}),
		...(deskHeaderPaddingLeft !== undefined &&
			deskHeaderPaddingLeft !== '' && {
				paddingLeft: `${deskHeaderPaddingLeft}${headerPaddingUnit}`,
			}),
	};
	// Footer Padding
	const deskFooterPaddingStyles = {
		...(deskFooterPaddingTop !== undefined &&
			deskFooterPaddingTop !== '' && {
				paddingTop: `${deskFooterPaddingTop}${footerPaddingUnit}`,
			}),
		...(deskFooterPaddingRight !== undefined &&
			deskFooterPaddingRight !== '' && {
				paddingRight: `${deskFooterPaddingRight}${footerPaddingUnit}`,
			}),
		...(deskFooterPaddingBottom !== undefined &&
			deskFooterPaddingBottom !== '' && {
				paddingBottom: `${deskFooterPaddingBottom}${footerPaddingUnit}`,
			}),
		...(deskFooterPaddingLeft !== undefined &&
			deskFooterPaddingLeft !== '' && {
				paddingLeft: `${deskFooterPaddingLeft}${footerPaddingUnit}`,
			}),
	};

		// Designation Typography
	const designationTypographyStyles = {
		'font-family': designationTypography?.fontFamily,
		'font-weight': designationTypography?.fontWeight,
		'font-style': designationTypography?.fontStyle,
		'text-transform': designationTypography?.textTransform,
		'line-height': designationTypography?.lineHeight,
		'letter-spacing': designationTypography?.letterSpacing,
		'word-spacing': designationTypography?.wordSpacing,
	};
	const addDesignationPx = (value) => {
		if (typeof value === 'number') {
			return `${value}px`;
		}
		return value;
	};
	designationTypographyStyles['letter-spacing'] = addDesignationPx(
		designationTypographyStyles['letter-spacing']
	);
	designationTypographyStyles['word-spacing'] = addDesignationPx(
		designationTypographyStyles['word-spacing']
	);

	const mergedDesignationTypographyStyles = {
		...designationTypographyStyles,
	};
	const designationTypographyStyle = Object.keys(
		mergedDesignationTypographyStyles
	)
		.filter(
			(property) =>
				mergedDesignationTypographyStyles[property] !== undefined &&
				mergedDesignationTypographyStyles[property] !== ''
		)
		.map(
			(property) =>
				`${property}: ${mergedDesignationTypographyStyles[property]};`
		)
		.join(' ');
	const designationTypographyBlock =
		designationTypography.fontFamily ||
		designationTypography.fontWeight ||
		designationTypography.fontStyle ||
		designationTypography.textTransform ||
		designationTypography.lineHeight ||
		designationTypography.letterSpacing ||
		designationTypography.wordSpacing
			? `
		.${uniqueId} .bwdcvs-main-wrapper .profile-info .designation {
			${designationTypographyStyle}
		}
			`
			: '';
			// User Name Typography
	const userNameTypographyStyles = {
		'font-family': userNameTypography?.fontFamily,
		'font-weight': userNameTypography?.fontWeight,
		'font-style': userNameTypography?.fontStyle,
		'text-transform': userNameTypography?.textTransform,
		'line-height': userNameTypography?.lineHeight,
		'letter-spacing': userNameTypography?.letterSpacing,
		'word-spacing': userNameTypography?.wordSpacing,
	};
	const addHedingPx = (value) => {
		if (typeof value === 'number') {
			return `${value}px`;
		}
		return value;
	};
	userNameTypographyStyles['letter-spacing'] = addHedingPx(
		userNameTypographyStyles['letter-spacing']
	);
	userNameTypographyStyles['word-spacing'] = addHedingPx(
		userNameTypographyStyles['word-spacing']
	);

	const mergedUserNameTypographyStyles = {
		...userNameTypographyStyles,
	};
	const userNameTypographyStyle = Object.keys(mergedUserNameTypographyStyles)
		.filter(
			(property) =>
				mergedUserNameTypographyStyles[property] !== undefined &&
				mergedUserNameTypographyStyles[property] !== ''
		)
		.map(
			(property) =>
				`${property}: ${mergedUserNameTypographyStyles[property]};`
		)
		.join(' ');
	const userNameTypographyBlock =
		userNameTypography.fontFamily ||
		userNameTypography.fontWeight ||
		userNameTypography.fontStyle ||
		userNameTypography.textTransform ||
		userNameTypography.lineHeight ||
		userNameTypography.letterSpacing ||
		userNameTypography.wordSpacing
			? `
		.${uniqueId} .bwdcvs-main-wrapper .profile-info .first-name,
		.${uniqueId} .bwdcvs-main-wrapper .profile-info .last-name,
		.${uniqueId} .bwdcvs-main-wrapper .bwdcv-name-wrap .first-name,
		.${uniqueId} .bwdcvs-main-wrapper .bwdcv-name-wrap .last-name {
			${userNameTypographyStyle}
		}
			`
			: '';

			// About Title Typography
	const aboutTitleTypographyStyles = {
		'font-family': aboutTitleTypography?.fontFamily,
		'font-weight': aboutTitleTypography?.fontWeight,
		'font-style': aboutTitleTypography?.fontStyle,
		'text-transform': aboutTitleTypography?.textTransform,
		'line-height': aboutTitleTypography?.lineHeight,
		'letter-spacing': aboutTitleTypography?.letterSpacing,
		'word-spacing': aboutTitleTypography?.wordSpacing,
	};
	const addAboutTitlePx = (value) => {
		if (typeof value === 'number') {
			return `${value}px`;
		}
		return value;
	};
	aboutTitleTypographyStyles['letter-spacing'] = addAboutTitlePx(
		aboutTitleTypographyStyles['letter-spacing']
	);
	aboutTitleTypographyStyles['word-spacing'] = addAboutTitlePx(
		aboutTitleTypographyStyles['word-spacing']
	);

	const mergedAboutTitleTypographyStyles = {
		...aboutTitleTypographyStyles,
	};
	const aboutTitleTypographyStyle = Object.keys(
		mergedAboutTitleTypographyStyles
	)
		.filter(
			(property) =>
				mergedAboutTitleTypographyStyles[property] !== undefined &&
				mergedAboutTitleTypographyStyles[property] !== ''
		)
		.map(
			(property) =>
				`${property}: ${mergedAboutTitleTypographyStyles[property]};`
		)
		.join(' ');
	const aboutTitleTypographyBlock =
		aboutTitleTypography.fontFamily ||
		aboutTitleTypography.fontWeight ||
		aboutTitleTypography.fontStyle ||
		aboutTitleTypography.textTransform ||
		aboutTitleTypography.lineHeight ||
		aboutTitleTypography.letterSpacing ||
		aboutTitleTypography.wordSpacing
			? `
		.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .icon-title-wrap .section-title {
			${aboutTitleTypographyStyle}
		}
			`
			: '';
	// About Description Typography
	const aboutDescriptionTypographyStyles = {
		'font-family': aboutDescriptionTypography?.fontFamily,
		'font-weight': aboutDescriptionTypography?.fontWeight,
		'font-style': aboutDescriptionTypography?.fontStyle,
		'text-transform': aboutDescriptionTypography?.textTransform,
		'line-height': aboutDescriptionTypography?.lineHeight,
		'letter-spacing': aboutDescriptionTypography?.letterSpacing,
		'word-spacing': aboutDescriptionTypography?.wordSpacing,
	};
	const addAboutDescriptionPx = (value) => {
		if (typeof value === 'number') {
			return `${value}px`;
		}
		return value;
	};
	aboutDescriptionTypographyStyles['letter-spacing'] = addAboutDescriptionPx(
		aboutDescriptionTypographyStyles['letter-spacing']
	);
	aboutDescriptionTypographyStyles['word-spacing'] = addAboutDescriptionPx(
		aboutDescriptionTypographyStyles['word-spacing']
	);

	const mergedAboutDescriptionTypographyStyles = {
		...aboutDescriptionTypographyStyles,
	};
	const aboutDescriptionTypographyStyle = Object.keys(
		mergedAboutDescriptionTypographyStyles
	)
		.filter(
			(property) =>
				mergedAboutDescriptionTypographyStyles[property] !==
					undefined &&
				mergedAboutDescriptionTypographyStyles[property] !== ''
		)
		.map(
			(property) =>
				`${property}: ${mergedAboutDescriptionTypographyStyles[property]};`
		)
		.join(' ');
	const aboutDescriptionTypographyBlock =
		aboutDescriptionTypography.fontFamily ||
		aboutDescriptionTypography.fontWeight ||
		aboutDescriptionTypography.fontStyle ||
		aboutDescriptionTypography.textTransform ||
		aboutDescriptionTypography.lineHeight ||
		aboutDescriptionTypography.letterSpacing ||
		aboutDescriptionTypography.wordSpacing
			? `
		.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .description {
			${aboutDescriptionTypographyStyle}
		}
			`
			: '';
	const deskStyles = `
		${
			deskNameFontSize !== undefined && deskNameFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .first-name,
				.${uniqueId} .bwdcvs-main-wrapper .profile-info .last-name {
						font-size: ${deskNameFontSize}${nameFontSizeUnit}!important;
					}`
				: ' '
		}
		${
			deskImageSize !== undefined && deskImageSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-img {
						width: ${deskImageSize}${imageSizeUnit}!important;
						height: ${deskImageSize}${imageSizeUnit}!important;
					}`
				: ' '
		}
		${
			deskImageBorderRadius !== undefined && deskImageBorderRadius !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-img,
				.${uniqueId} .bwdcvs-main-wrapper .profile-img img {
					border-radius: ${deskImageBorderRadius}${imageBorderRadiusUnit}
				}`
				: ' '
		}
		${
			headerBackgroundColor !== undefined && headerBackgroundColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-header {
				background-color: ${headerBackgroundColor};
			}`
				: ' '
		}
		${
			footerBgColor !== undefined && footerBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .footer {
				background-color: ${footerBgColor};
			}`
				: ' '
		}
		${
			bodyBgColor !== undefined && bodyBgColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper {
				background-color: ${bodyBgColor};
			}`
				: ' '
		}
		${
			leftColumnBgColor !== undefined && leftColumnBgColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-left-content {
				background-color: ${leftColumnBgColor}!important;
			}`
				: ' '
		}
		${
			rightColumnBgColor !== undefined && rightColumnBgColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-right-content{
				background-color: ${rightColumnBgColor}!important;
			}`
				: ' '
		}
		${
			userNameColor !== undefined && userNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .first-name,
				.${uniqueId} .bwdcvs-main-wrapper .profile-info .last-name,
				.${uniqueId} .bwdcvs-main-wrapper .bwdcv-name-wrap .first-name,
				.${uniqueId} .bwdcvs-main-wrapper .bwdcv-name-wrap .last-name {
				color: ${userNameColor}!important;
			}`
				: ' '
		}
		${
			designationColor !== undefined && designationColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .designation {
					color: ${designationColor}!important;
				}`
				: ' '
		}
		${
			deskDesignationFontSize !== undefined &&
			deskDesignationFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .designation {
					font-size: ${deskDesignationFontSize}${designationFontSizeUnit}!important;
				}`
				: ' '
		}
		${
			iconColor !== undefined && iconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .social-icon .icon svg {
			fill: ${iconColor}!important;
			}`
				: ' '
		}
		${
			iconBackgroundColor !== undefined && iconBackgroundColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .social-icon .icon {
				background-color: ${iconBackgroundColor}!important;
			}`
				: ' '
		}
		${
			deskIconSize !== undefined && deskIconSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .social-icon .icon svg{
				width: ${deskIconSize}${iconSizeUnit}!important;
				height: ${deskIconSize}${iconSizeUnit}!important;
			}`
				: ' '
		}
		${
			deskIconBorderRadius !== undefined && deskIconBorderRadius !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .social-icon .icon {
				border-radius: ${deskIconBorderRadius}${iconBorderRadiusUnit}!important;
			}`
				: ' '
		}
		${
			deskIconGap !== undefined && deskIconGap !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .social-icon {
				gap: ${deskIconGap}${iconGapUnit}!important;
			}`
				: ' '
		}
		${
			deskIconRoundSize !== undefined && deskIconRoundSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .profile-info .social-icon .icon {
				width: ${deskIconRoundSize}${iconRoundSizeUnit}!important;
				height: ${deskIconRoundSize}${iconRoundSizeUnit}!important;
			}`
				: ' '
		}
		${
			Object.keys(deskAboutPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap{ ${convertToCss(
						deskAboutPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskContactPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .icon-title-wrap{ ${convertToCss(
						deskContactPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskSkillPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap{ ${convertToCss(
						deskSkillPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskLanguagePaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap{ ${convertToCss(
						deskLanguagePaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskHobbyPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap{ ${convertToCss(
						deskHobbyPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskEducationPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap{ ${convertToCss(
						deskEducationPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskExperiencePaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap{ ${convertToCss(
						deskExperiencePaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskReferencePaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap{ ${convertToCss(
						deskReferencePaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskAboutSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .about-content-wrap{ ${convertToCss(
						deskAboutSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskContactSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .cv-contact{ ${convertToCss(
						deskContactSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskSkillSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .skills{ ${convertToCss(
						deskSkillSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskLanguageSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .languages{ ${convertToCss(
						deskLanguageSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskHobbySectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .hobbies{ ${convertToCss(
						deskHobbySectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskEducationSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .education{ ${convertToCss(
						deskEducationSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskExperienceSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .experience{ ${convertToCss(
						deskExperienceSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskReferenceSectionPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .reference{ ${convertToCss(
						deskReferenceSectionPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskHeaderPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-header{ ${convertToCss(
						deskHeaderPaddingStyles
				  )}}`
				: ' '
		}
		${
			Object.keys(deskFooterPaddingStyles).length > 0
				? `.${uniqueId} .bwdcvs-main-wrapper .footer{ ${convertToCss(
						deskFooterPaddingStyles
				  )}}`
				: ' '
		}
		${
			aboutTitleColor !== undefined && aboutTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap .section-title {
				color: ${aboutTitleColor}!important;
			}`
				: ' '
		}
		${
			aboutTitleIconColor !== undefined && aboutTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap svg{
				fill: ${aboutTitleIconColor}!important;
			}`
				: ' '
		}
		${
			aboutTitleBgColor !== undefined && aboutTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap {
				background-color: ${aboutTitleBgColor}!important;
			}`
				: ' '
		}
		${
			aboutDescriptionColor !== undefined && aboutDescriptionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-about .description {
				color: ${aboutDescriptionColor}!important;
			}`
				: ' '
		}
		${
			aboutDateOfBirthColor !== undefined && aboutDateOfBirthColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-about .birth-date-wrap {
				color: ${aboutDateOfBirthColor}!important;
			}`
				: ' '
		}
		${
			aboutNationalityColor !== undefined && aboutNationalityColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-about .nationality-wrap {
				color: ${aboutNationalityColor}!important;
			}`
				: ' '
		}
		${
			contactTitleColor !== undefined && contactTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .section-title {
				color: ${contactTitleColor}!important;
			}`
				: ' '
		}
		${
			contactTitleIconColor !== undefined && contactTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact svg{
				fill: ${contactTitleIconColor}!important;
			}`
				: ' '
		}
		${
			contactTitleBgColor !== undefined && contactTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .icon-title-wrap {
				background-color: ${contactTitleBgColor}!important;
			}`
				: ' '
		}
		${
			addressColor !== undefined && addressColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-contact {
				color: ${addressColor}!important;
			}`
				: ' '
		}
		${
			deskAboutTitleFontSize !== undefined &&
			deskAboutTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap .section-title {
				font-size: ${deskAboutTitleFontSize}${aboutTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskAboutTitleIconFontSize !== undefined &&
			deskAboutTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap svg {
				width: ${deskAboutTitleIconFontSize}${aboutTitleIconFontSizeUnit};
				height: ${deskAboutTitleIconFontSize}${aboutTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskAboutDescriptionFontSize !== undefined &&
			deskAboutDescriptionFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-about .description {
				font-size: ${deskAboutDescriptionFontSize}${aboutDescriptionFontSizeUnit};
			}`
				: ' '
		}
		${
			deskDateOfBirthFontSize !== undefined &&
			deskDateOfBirthFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-about .birth-date-wrap{
				font-size: ${deskDateOfBirthFontSize}${dateOfBirthFontSizeUnit};
			}`
				: ' '
		}
		${
			deskNationalityFontSize !== undefined &&
			deskNationalityFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-about .nationality-wrap{
				font-size: ${deskNationalityFontSize}${nationalityFontSizeUnit};
			}`
				: ' '
		}
		${
			deskContactFontSize !== undefined && deskContactFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-contact{
				font-size: ${deskContactFontSize}${contactFontSizeUnit};
			}`
				: ' '
		}
		${
			skillTitleBgColor !== undefined && skillTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap {
				background-color: ${skillTitleBgColor}!important;
			}`
				: ' '
		}
		${
			skillTitleColor !== undefined && skillTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap .section-title {
				color: ${skillTitleColor};
			}`
				: ' '
		}
		${
			skillTitleIconColor !== undefined && skillTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap svg {
				fill: ${skillTitleIconColor};
			}`
				: ' '
		}
		${
			skillNameColor !== undefined && skillNameColor !== ''
				? `.${uniqueId} .cv-skill .bwdcv-pb-label {
				color: ${skillNameColor}!important;
			}`
				: ' '
		}
		${
			skillPercentageColor !== undefined && skillPercentageColor !== ''
				? `.${uniqueId} .cv-skill .bwdcv-percentage-counter{
				color: ${skillPercentageColor}!important;
			}`
				: ' '
		}
		${
			skillTopBgColor !== undefined && skillTopBgColor !== ''
				? `.${uniqueId} .cv-skill .bwdcv-per-val {
				background-color: ${skillTopBgColor}!important;
			}`
				: ' '
		}
		${
			skillBottomBgColor !== undefined && skillBottomBgColor !== ''
				? `.${uniqueId} .cv-skill .bwdcv-progress-bar {
				background-color: ${skillBottomBgColor}!important;
			}`
				: ' '
		}
		${
			deskSkillTitleFontSize !== undefined &&
			deskSkillTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap .section-title {
				font-size: ${deskSkillTitleFontSize}${skillTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskSkillBarGap !== undefined && deskSkillBarGap !== ''
				? `.${uniqueId} .cv-skill .bwdcv-pb-name {
				margin-bottom: ${deskSkillBarGap}${skillBarGapUnit};
			}`
				: ' '
		}
		${
			deskSkillTitleIconFontSize !== undefined &&
			deskSkillTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap svg {
				width: ${deskSkillTitleIconFontSize}${skillTitleIconFontSizeUnit};
				height: ${deskSkillTitleIconFontSize}${skillTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskSkillNameFontSize !== undefined && deskSkillNameFontSize !== ''
				? `.${uniqueId} .cv-skill .bwdcv-pb-label {
				font-size: ${deskSkillNameFontSize}${skillNameFontSizeUnit};
			}`
				: ' '
		}
		${
			deskSkillPercentageFontSize !== undefined &&
			deskSkillPercentageFontSize !== ''
				? `.${uniqueId} .cv-skill .bwdcv-percentage-counter {
				font-size: ${deskSkillPercentageFontSize}${skillPercentageFontSizeUnit};
			}`
				: ' '
		}
		${
			languageTitleBgColor !== undefined && languageTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap {
				background-color: ${languageTitleBgColor}!important;
			}`
				: ' '
		}
		${
			languageTitleColor !== undefined && languageTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap .section-title {
				color: ${languageTitleColor};
			}`
				: ' '
		}
		${
			languageTitleIconColor !== undefined &&
			languageTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap svg {
				fill: ${languageTitleIconColor};
			}`
				: ' '
		}
		${
			languageNameColor !== undefined && languageNameColor !== ''
				? `.${uniqueId} .cv-language .bwdcv-pb-label {
				color: ${languageNameColor}!important;
			}`
				: ' '
		}
		${
			languagePercentageColor !== undefined &&
			languagePercentageColor !== ''
				? `.${uniqueId} .cv-language .bwdcv-percentage-counter{
				color: ${languagePercentageColor}!important;
			}`
				: ' '
		}
		${
			languageTopBgColor !== undefined && languageTopBgColor !== ''
				? `.${uniqueId} .cv-language .bwdcv-per-val {
				background-color: ${languageTopBgColor}!important;
			}`
				: ' '
		}
		${
			languageBottomBgColor !== undefined && languageBottomBgColor !== ''
				? `.${uniqueId} .cv-language .bwdcv-progress-bar {
				background-color: ${languageBottomBgColor}!important;
			}`
				: ' '
		}
		${
			deskLanguageTitleFontSize !== undefined &&
			deskLanguageTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap .section-title {
				font-size: ${deskLanguageTitleFontSize}${languageTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskLanguageBarGap !== undefined && deskLanguageBarGap !== ''
				? `.${uniqueId} .cv-language .bwdcv-pb-name {
				margin-bottom: ${deskLanguageBarGap}${languageBarGapUnit};
			}`
				: ' '
		}

		${
			deskLanguageTitleIconFontSize !== undefined &&
			deskLanguageTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap svg {
				width: ${deskLanguageTitleIconFontSize}${languageTitleIconFontSizeUnit};
				height: ${deskLanguageTitleIconFontSize}${languageTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskLanguageNameFontSize !== undefined &&
			deskLanguageNameFontSize !== ''
				? `.${uniqueId} .cv-language .bwdcv-pb-label {
				font-size: ${deskLanguageNameFontSize}${languageNameFontSizeUnit};
			}`
				: ' '
		}
		${
			deskLanguagePercentageFontSize !== undefined &&
			deskLanguagePercentageFontSize !== ''
				? `.${uniqueId} .cv-body .bwdcv-main-wrapper .section-languages .bwdcv-percentage-counter {
				font-size: ${deskLanguagePercentageFontSize}${languagePercentageFontSizeUnit};
			}`
				: ' '
		}
		${
			hobbyTitleBgColor !== undefined && hobbyTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap {
				background-color: ${hobbyTitleBgColor};
			}`
				: ' '
		}
		${
			hobbyTitleColor !== undefined && hobbyTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap .section-title {
				color: ${hobbyTitleColor};
			}`
				: ' '
		}
		${
			hobbyTitleIconColor !== undefined && hobbyTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap svg {
				fill: ${hobbyTitleIconColor};
			}`
				: ' '
		}
		${
			hobbyNameColor !== undefined && hobbyNameColor !== ''
				? `.${uniqueId} .section-hobbies .cv-hobby .hobby-name {
				color: ${hobbyNameColor}!important;
			}`
				: ' '
		}
		${
			hobbyIconColor !== undefined && hobbyIconColor !== ''
				? `.${uniqueId} .section-hobbies .cv-hobby .icon svg {
				fill: ${hobbyIconColor}!important;
			}`
				: ' '
		}
		${
			deskHobbyTitleFontSize !== undefined &&
			deskHobbyTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap .section-title {
				font-size: ${deskHobbyTitleFontSize}${hobbyTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskHobbyTitleIconFontSize !== undefined &&
			deskHobbyTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap svg {
				width: ${deskHobbyTitleIconFontSize}${hobbyTitleIconFontSizeUnit};
				height: ${deskHobbyTitleIconFontSize}${hobbyTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskHobbyNameFontSize !== undefined && deskHobbyNameFontSize !== ''
				? `.${uniqueId} .section-hobbies .cv-hobby .hobby-name {
				font-size: ${deskHobbyNameFontSize}${hobbyNameFontSizeUnit};
			}`
				: ' '
		}
		${
			deskHobbyIconFontSize !== undefined && deskHobbyIconFontSize !== ''
				? `.${uniqueId} .section-hobbies .cv-hobby .icon svg {
				width: ${deskHobbyIconFontSize}${hobbyIconFontSizeUnit};
				height: ${deskHobbyIconFontSize}${hobbyIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskHobbyItemGap !== undefined && deskHobbyItemGap !== ''
				? `.${uniqueId} .style2 .cv-builder-information .cv-body .bwdcv-main-wrapper .section-hobbies .content-wrapper.hobbies {
				gap: ${deskHobbyItemGap}${hobbyItemGapUnit}!important;
			}`
				: ' '
		}
		${
			deskHobbyNameFontSize !== undefined && deskHobbyNameFontSize !== ''
				? `.${uniqueId} .section-hobbies .cv-hobby .hobby-name {
				font-size: ${deskHobbyNameFontSize}${hobbyNameFontSizeUnit};
			}`
				: ' '
		}
		${
			deskStudyFieldFontSize !== undefined &&
			deskStudyFieldFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .study-field {
				font-size: ${deskStudyFieldFontSize}${studyFieldFontSizeUnit}!important;
			}`
				: ' '
		}
		${
			deskEducationDegreeNameFontSize !== undefined &&
			deskEducationDegreeNameFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .degree-name{
				font-size: ${deskEducationDegreeNameFontSize}${educationDegreeNameFontSizeUnit}!important;
			}`
				: ' '
		}
		${
			deskEducationDescriptionFontSize !== undefined &&
			deskEducationDescriptionFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .description {
				font-size: ${deskEducationDescriptionFontSize}${educationDescriptionFontSizeUnit}!important;
			}`
				: ' '
		}
		${
			deskEducationDateFontSize !== undefined &&
			deskEducationDateFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .duration {
				font-size: ${deskEducationDateFontSize}${educationDateFontSizeUnit}!important;
			}`
				: ' '
		}

		${
			educationTitleBgColor !== undefined && educationTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap {
				background-color: ${educationTitleBgColor}!important;
			}`
				: ' '
		}
		${
			educationTitleColor !== undefined && educationTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap .section-title {
				color: ${educationTitleColor}!important;
			}`
				: ' '
		}
		${
			educationTitleIconColor !== undefined &&
			educationTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap svg {
				fill: ${educationTitleIconColor}!important;
			}`
				: ' '
		}
		${
			institutionNameColor !== undefined && institutionNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .institution,
			.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .city-country {
				color: ${institutionNameColor};
			}`
				: ' '
		}
		${
			degreeNameColor !== undefined && degreeNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .degree-name {
				color: ${degreeNameColor};
			}`
				: ' '
		}
		${
			educationDescriptionColor !== undefined &&
			educationDescriptionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .description {
				color: ${educationDescriptionColor}!important;
			}`
				: ' '
		}
		${
			studyFieldColor !== undefined && studyFieldColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .study-field {
				color: ${studyFieldColor};
			}`
				: ' '
		}
		${
			educationPassingDateColor !== undefined &&
			educationPassingDateColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .duration {
				color: ${educationPassingDateColor};
			}`
				: ' '
		}

		${
			deskEducationTitleFontSize !== undefined &&
			deskEducationTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap .section-title {
				font-size: ${deskEducationTitleFontSize}${educationTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskEducationTitleIconFontSize !== undefined &&
			deskEducationTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap svg {
				width: ${deskEducationTitleIconFontSize}${educationTitleIconFontSizeUnit};
				height: ${deskEducationTitleIconFontSize}${educationTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskEducationInstitutionFontSize !== undefined &&
			deskEducationInstitutionFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .education-content-wrap .institution,
			.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .education-content-wrap .city-country {
				font-size: ${deskEducationInstitutionFontSize}${educationInstitutionFontSizeUnit};
			}`
				: ' '
		}

		${
			deskExperienceTitleFontSize !== undefined &&
			deskExperienceTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap .section-title {
				font-size: ${deskExperienceTitleFontSize}${experienceTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskExperienceTitleIconFontSize !== undefined &&
			deskExperienceTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap svg {
				width: ${deskExperienceTitleIconFontSize}${experienceTitleIconFontSizeUnit};
				height: ${deskExperienceTitleIconFontSize}${experienceTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskExperienceCompanyFontSize !== undefined &&
			deskExperienceCompanyFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .company-name {
				font-size: ${deskExperienceCompanyFontSize}${experienceCompanyFontSizeUnit};
			}`
				: ' '
		}
		${
			deskExperienceDescriptionFontSize !== undefined &&
			deskExperienceDescriptionFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .description {
				font-size: ${deskExperienceDescriptionFontSize}${experienceDescriptionFontSizeUnit};
			}`
				: ' '
		}
		${
			deskExperienceDesignationFontSize !== undefined &&
			deskExperienceDesignationFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .designation {
				font-size: ${deskExperienceDesignationFontSize}${experienceDesignationFontSizeUnit};
			}`
				: ' '
		}
		${
			deskExperienceDateFontSize !== undefined &&
			deskExperienceDateFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .duration {
				font-size: ${deskExperienceDateFontSize}${experienceDateFontSizeUnit};
			}`
				: ' '
		}
		${
			experienceTitleBgColor !== undefined &&
			experienceTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap {
				background-color: ${experienceTitleBgColor}!important;
			}`
				: ' '
		}
		${
			experienceTitleColor !== undefined && experienceTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap .section-title {
				color: ${experienceTitleColor}!important;
			}`
				: ' '
		}
		${
			experienceTitleIconColor !== undefined &&
			experienceTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap svg {
				fill: ${experienceTitleIconColor};
			}`
				: ' '
		}
		${
			companyNameColor !== undefined && companyNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .company-name {
				color: ${companyNameColor};
			}`
				: ' '
		}
		${
			experienceDescriptionColor !== undefined &&
			experienceDescriptionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .description {
				color: ${experienceDescriptionColor}!important;
			}`
				: ' '
		}
		${
			experienceDateColor !== undefined && experienceDateColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .duration {
				color: ${experienceDateColor};
			}`
				: ' '
		}
		${
			experienceDesignationColor !== undefined &&
			experienceDesignationColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .designation {
				color: ${experienceDesignationColor};
			}`
				: ' '
		}
		${
			referenceTitleColor !== undefined && referenceTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap .section-title {
				color: ${referenceTitleColor}!important;
			}`
				: ' '
		}
		${
			referenceTitleBgColor !== undefined && referenceTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap {
				background-color: ${referenceTitleBgColor}!important;
			}`
				: ' '
		}
		${
			referenceTitleIconColor !== undefined &&
			referenceTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap svg {
				fill: ${referenceTitleIconColor};
			}`
				: ' '
		}
		${
			referenceNameColor !== undefined && referenceNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .name {
				color: ${referenceNameColor};
			}`
				: ' '
		}
		${
			referenceJobPositionColor !== undefined &&
			referenceJobPositionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .job-position {
				color: ${referenceJobPositionColor};
			}`
				: ' '
		}
		${
			referenceCompanyColor !== undefined && referenceCompanyColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .company {
				color: ${referenceCompanyColor};
			}`
				: ' '
		}
		${
			referencePhoneColor !== undefined && referencePhoneColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .phone {
				color: ${referencePhoneColor};
			}`
				: ' '
		}
		${
			referenceRelationColor !== undefined &&
			referenceRelationColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .relation {
				color: ${referenceRelationColor};
			}`
				: ' '
		}
		${
			deskReferenceTitleFontSize !== undefined &&
			deskReferenceTitleFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap .section-title{
				font-size: ${deskReferenceTitleFontSize}${referenceTitleFontSizeUnit};
			}`
				: ' '
		}
		${
			deskReferenceTitleIconFontSize !== undefined &&
			deskReferenceTitleIconFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap svg {
				width: ${deskReferenceTitleIconFontSize}${referenceTitleIconFontSizeUnit};
				height: ${deskReferenceTitleIconFontSize}${referenceTitleIconFontSizeUnit};
			}`
				: ' '
		}
		${
			deskReferenceNameFontSize !== undefined &&
			deskReferenceNameFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .name {
				font-size: ${deskReferenceNameFontSize}${referenceNameFontSizeUnit};
			}`
				: ' '
		}
		${
			deskReferenceJobPositionFontSize !== undefined &&
			deskReferenceJobPositionFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .job-position {
				font-size: ${deskReferenceJobPositionFontSize}${referenceJobPositionFontSizeUnit};
			}`
				: ' '
		}
		${
			deskReferenceCompanyFontSize !== undefined &&
			deskReferenceCompanyFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .company {
				font-size: ${deskReferenceCompanyFontSize}${referenceCompanyFontSizeUnit};
			}`
				: ' '
		}
		${
			deskReferencePhoneFontSize !== undefined &&
			deskReferencePhoneFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .phone {
				font-size: ${deskReferencePhoneFontSize}${referencePhoneFontSizeUnit};
			}`
				: ' '
		}
		${
			deskReferenceRelationFontSize !== undefined &&
			deskReferenceRelationFontSize !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .relation {
				font-size: ${deskReferenceRelationFontSize}${referenceRelationFontSizeUnit};
			}`
				: ' '
		}
		
		
		${designationTypographyBlock}
		${userNameTypographyBlock}
		${aboutTitleTypographyBlock}
		${aboutDescriptionTypographyBlock}
		`;
	// User Name Typography
	const typographyStyles = {
		'font-family': typography?.fontFamily
	};
	const mergedTypographyStyles = {
		...typographyStyles,
	};
	const typographyStyle = Object.keys(mergedTypographyStyles)
		.filter(
			(property) =>
				mergedTypographyStyles[property] !== undefined &&
				mergedTypographyStyles[property] !== ''
		)
		.map((property) => `${property}: ${mergedTypographyStyles[property]};`)
		.join(' ');
	const typographyBlock =
		typography.fontFamily
			? `
	.${uniqueId} .bwdcvs-main-wrapper .profile-info .first-name,
	.${uniqueId} .bwdcvs-main-wrapper .profile-info .last-name,
	.${uniqueId} .bwdcvs-main-wrapper .bwdcv-name-wrap .first-name,
	.${uniqueId} .bwdcvs-main-wrapper .bwdcv-name-wrap .last-name,
	.${uniqueId} .bwdcvs-main-wrapper .cv-header .profile-info .designation,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .icon-title-wrap .section-title,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .description,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .about-content-wrap .birth-date-wrap,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .about-content-wrap .nationality-wrap,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-contact,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .bwdcv-pb-label,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-hobby .hobby-name,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .study-field,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .degree-name,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .institution,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .city-country,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .description,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .company-name,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .designation,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .description,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .name,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .job-position,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .company,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .relation,
	.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .phone,
	.${uniqueId} .bwdcvs-main-wrapper .footer .footer-content .footer-btn,
	.${uniqueId} .style24 .cv-builder-information .cv-body .bwdcv-about .bwdcv-about-content,
	.${uniqueId} .style24 .cv-builder-information .cv-body .bwdcv-about .bwdcv-about-title,
	.${uniqueId} .style24 .cv-builder-information .cv-header .bwdcv-contact-info,
	.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .bwdcv-pb-name .bwdcv-progress-bar .bwdcv-percentage-counter,
	.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .duration,
	.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-experience .duration{
		${typographyStyle}
	}
		`
			: '';

	const aboutStyles = `
		${
			aboutTitleColor !== undefined && aboutTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap .section-title {
						color: ${aboutTitleColor} !important;
					}`
				: ' '
		}
		${
			aboutTitleBgColor !== undefined && aboutTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap {
						background-color: ${aboutTitleBgColor} !important;
					}`
				: ' '
		}
		${
			aboutTitleIconColor !== undefined && aboutTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .icon-title-wrap svg {
						fill: ${aboutTitleIconColor} !important;
					}`
				: ' '
		}
		${
			aboutDescColor !== undefined && aboutDescColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-about .description {
						color: ${aboutDescColor} !important;
					}`
				: ' '
		}
		${
			DateOfBirthColor !== undefined && DateOfBirthColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper  .about-content-wrap .birth-date-wrap {
						color: ${DateOfBirthColor} !important;
					}`
				: ' '
		}
		${
			nationalityColor !== undefined && nationalityColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .about-content-wrap .nationality-wrap {
						color: ${nationalityColor} !important;
					}`
				: ' '
		}
		${
			contactTitleColor !== undefined && contactTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .icon-title-wrap .section-title {
						color: ${contactTitleColor} !important;
					}`
				: ' '
		}
		${
			contactTitleBgColor !== undefined && contactTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .icon-title-wrap {
						background-color: ${contactTitleBgColor} !important;
					}`
				: ' '
		}
		${
			contactTitleIconColor !== undefined && contactTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-contact .icon-title-wrap svg {
						fill: ${contactTitleIconColor} !important;
					}`
				: ' '
		}
		${
			contactContentColor !== undefined && contactContentColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-contact {
						color: ${contactContentColor} !important;
					}`
				: ' '
		}

		${
			skillsTitleColor !== undefined && skillsTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap .section-title {
						color: ${skillsTitleColor} !important;
					}`
				: ' '
		}
		${
			skillsTitleBgColor !== undefined && skillsTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap {
						background-color: ${skillsTitleBgColor} !important;
					}`
				: ' '
		}
		${
			skillsTitleIconColor !== undefined && skillsTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-skills .icon-title-wrap svg {
						fill: ${skillsTitleIconColor} !important;
					}`
				: ' '
		}
		${
			skillNameColor !== undefined && skillNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-skill .bwdcv-pb-label {
						color: ${skillNameColor} !important;
					}`
				: ' '
		}
		${
			skillPercentageColor !== undefined && skillPercentageColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-skill .bwdcv-percentage-counter {
						color: ${skillPercentageColor} !important;
					}`
				: ' '
		}
		${
			skillProgressBottomColor !== undefined && skillProgressBottomColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-skill .bwdcv-progress-bar {
						background-color: ${skillProgressBottomColor} !important;
					}`
				: ' '
		}
		${
			skillProgressTopColor !== undefined && skillProgressTopColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-skill .bwdcv-progress-bar .bwdcv-per-val{
						background-color: ${skillProgressTopColor} !important;
					}`
				: ' '
		}
		${
			languageTitleColor !== undefined && languageTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap .section-title {
						color: ${languageTitleColor} !important;
					}`
				: ' '
		}
		${
			languageTitleBgColor !== undefined && languageTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap {
						background-color: ${languageTitleBgColor} !important;
					}`
				: ' '
		}
		${
			languageTitleIconColor !== undefined && languageTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-languages .icon-title-wrap svg {
						fill: ${languageTitleIconColor} !important;
					}`
				: ' '
		}
		${
			languageNameColor !== undefined && languageNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-language .bwdcv-pb-label {
						color: ${languageNameColor} !important;
					}`
				: ' '
		}
		${
			languagePercentageColor !== undefined && languagePercentageColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-language .bwdcv-percentage-counter {
						color: ${languagePercentageColor} !important;
					}`
				: ' '
		}
		${
			languageProgressBottomColor !== undefined && languageProgressBottomColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-language .bwdcv-progress-bar {
						background-color: ${languageProgressBottomColor} !important;
					}`
				: ' '
		}
		${
			languageProgressTopColor !== undefined && languageProgressTopColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-language .bwdcv-progress-bar .bwdcv-per-val{
						background-color: ${languageProgressTopColor} !important;
					}`
				: ' '
		}
		${
			hobbiesTitleColor !== undefined && hobbiesTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap .section-title {
						color: ${hobbiesTitleColor} !important;
					}`
				: ' '
		}
		${
			hobbiesTitleBgColor !== undefined && hobbiesTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap {
						background-color: ${hobbiesTitleBgColor} !important;
					}`
				: ' '
		}
		${
			hobbiesTitleIconColor !== undefined && hobbiesTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-hobbies .icon-title-wrap svg {
						fill: ${hobbiesTitleIconColor} !important;
					}`
				: ' '
		}
		${
			hobbyNameColor !== undefined && hobbyNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-hobby .hobby-name {
						color: ${hobbyNameColor} !important;
					}`
				: ' '
		}
		${
			hobbyIconColor !== undefined && hobbyIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-hobby .icon svg {
						fill: ${hobbyIconColor} !important;
					}`
				: ' '
		}
		${
			educationTitleColor !== undefined && educationTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap .section-title {
						color: ${educationTitleColor} !important;
					}`
				: ' '
		}
		${
			educationTitleBgColor !== undefined && educationTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap {
						background-color: ${educationTitleBgColor} !important;
					}`
				: ' '
		}
		${
			educationTitleIconColor !== undefined && educationTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-education .icon-title-wrap svg {
						fill: ${educationTitleIconColor} !important;
					}`
				: ' '
		}
		${
			educationDescriptionColor !== undefined && educationDescriptionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .description {
						color: ${educationDescriptionColor} !important;
					}`
				: ' '
		}
		${
			educationYearColor !== undefined && educationYearColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .duration {
						color: ${educationYearColor} !important;
					}`
				: ' '
		}
		${
			educationRoundShapeColor !== undefined && educationRoundShapeColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .study-field::after {
						background-color: ${educationRoundShapeColor} !important;
					}`
				: ' '
		}
		${
			educationLineColor !== undefined && educationLineColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap::before {
						background-color: ${educationLineColor} !important;
					}`
				: ' '
		}
		${
			studyFieldColor !== undefined && studyFieldColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .study-field {
						color: ${studyFieldColor} !important;
					}`
				: ' '
		}
		${
			degreeNameColor !== undefined && degreeNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .degree-name {
						color: ${degreeNameColor} !important;
					}`
				: ' '
		}
		${
			institutionColor !== undefined && institutionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .institution,
				.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-education .education-content-wrap .city-country {
						color: ${institutionColor} !important;
					}`
				: ' '
		}
		${
			experienceTitleColor !== undefined && experienceTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap .section-title {
						color: ${experienceTitleColor} !important;
					}`
				: ' '
		}
		${
			experienceTitleBgColor !== undefined && experienceTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap {
						background-color: ${experienceTitleBgColor} !important;
					}`
				: ' '
		}
		${
			experienceTitleIconColor !== undefined && experienceTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-experience .icon-title-wrap svg {
						fill: ${experienceTitleIconColor} !important;
					}`
				: ' '
		}
		${
			experienceDescriptionColor !== undefined && experienceDescriptionColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .description {
						color: ${experienceDescriptionColor} !important;
					}`
				: ' '
		}
		${
			experienceCompanyNameColor !== undefined && experienceCompanyNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .company-name {
						color: ${experienceCompanyNameColor} !important;
					}`
				: ' '
		}
		${
			experienceDesignationColor !== undefined && experienceDesignationColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .designation {
						color: ${experienceDesignationColor} !important;
					}`
				: ' '
		}
		${
			experienceDurationColor !== undefined && experienceDurationColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-experience .duration {
						color: ${experienceDurationColor} !important;
					}`
				: ' '
		}
		${
			experienceRoundShapeColor !== undefined && experienceRoundShapeColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-experience .company-name::after{
						background-color: ${experienceRoundShapeColor} !important;
					}`
				: ' '
		}
		${
			experienceLineColor !== undefined && experienceLineColor !== ''
				? `.${uniqueId} .cv-builder-information .cv-body .bwdcv-main-wrapper .cv-experience::before {
						background-color: ${experienceLineColor} !important;
					}`
				: ' '
		}
		${
			referenceTitleColor !== undefined && referenceTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap .section-title {
						color: ${referenceTitleColor} !important;
					}`
				: ' '
		}
		${
			referenceTitleBgColor !== undefined && referenceTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap {
						background-color: ${referenceTitleBgColor} !important;
					}`
				: ' '
		}
		${
			referenceTitleIconColor !== undefined && referenceTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-reference .icon-title-wrap svg {
						fill: ${referenceTitleIconColor} !important;
					}`
				: ' '
		}
		${
			referenceNameColor !== undefined && referenceNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .name {
						color: ${referenceNameColor} !important;
					}`
				: ' '
		}
		${
			referenceContentColor !== undefined && referenceContentColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .company,
				.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .job-position,
				.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .phone,
				.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .cv-reference .relation {
						color: ${referenceContentColor} !important;
					}`
				: ' '
		}
		${
			awardNameColor !== undefined && awardNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-awards .cv-awards {
						color: ${awardNameColor} !important;
					}`
				: ' '
		}
		${
			awardArrowColor !== undefined && awardArrowColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-awards .cv-awards::before {
						border-inline-start: 11px solid ${awardArrowColor};
						border-block-start: 6px solid transparent;
						border-block-end: 6px solid transparent;
					}`
				: ' '
		}
		${
			awardTitleColor !== undefined && awardTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-awards .icon-title-wrap .section-title {
						color: ${awardTitleColor} !important;
					}`
				: ' '
		}
		${
			awardTitleBgColor !== undefined && awardTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-awards .icon-title-wrap {
						background-color: ${awardTitleBgColor} !important;
					}`
				: ' '
		}
		${
			awardTitleIconColor !== undefined && awardTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-awards .icon-title-wrap svg {
						fill: ${awardTitleIconColor} !important;
					}`
				: ' '
		}
		${
			toolsNameColor !== undefined && toolsNameColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-tools .cv-tools .tool-item {
						color: ${toolsNameColor} !important;
					}`
				: ' '
		}
		${
			toolsTitleColor !== undefined && toolsTitleColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-tools .icon-title-wrap .section-title {
						color: ${toolsTitleColor} !important;
					}`
				: ' '
		}
		${
			toolsArrowColor !== undefined && toolsArrowColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-tools .cv-tools::before {
						border-inline-start: 11px solid ${toolsArrowColor};
						border-block-start: 6px solid transparent;
						border-block-end: 6px solid transparent;
					}`
				: ' '
		}
		${
			toolsTitleBgColor !== undefined && toolsTitleBgColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-tools .icon-title-wrap {
						background-color: ${toolsTitleBgColor} !important;
					}`
				: ' '
		}
		${
			toolsTitleIconColor !== undefined && toolsTitleIconColor !== ''
				? `.${uniqueId} .bwdcvs-main-wrapper .cv-body .bwdcv-main-wrapper .section-tools .icon-title-wrap svg {
						fill: ${toolsTitleIconColor} !important;
					}`
				: ' '
		}
		`;			

	useEffect(() => {
		if (typography?.fontFamily) {
			loadGoogleFont(typography.fontFamily);
		}
	}, [typography?.fontFamily]);

	let darkenOne,
		darkenTwo,
		darkenThree,
		lightenTwo,
		lightenFour,
		lightenFive;
	if (themeColor && typeof themeColor === 'string') {
		darkenOne = darken(0.1, themeColor);
		darkenTwo = darken(0.2, themeColor);
		darkenThree = darken(0.3, themeColor);
		lightenTwo = lighten(0.2, themeColor);
		lightenFour = lighten(0.4, themeColor);
		lightenFive = lighten(0.5, themeColor);
	}
	const themeStyles = getThemeStyles(
		uniqueId,
		themeColor,
		darkenOne,
		darkenTwo,
		lightenTwo,
		lightenFour,
		lightenFive,
		darkenThree
	);

	/**
	 * Block All Styles
	 */
	const blockStyleCss = `
		${themeStyles}
		${typographyBlock}
		${aboutStyles}
		${deskStyles}
	`;

	useEffect(() => {
		if (JSON.stringify(blockStyle) !== JSON.stringify(blockStyleCss)) {
			setAttributes({ blockStyle: blockStyleCss });
		}
	}, [attributes]);

	const currentData = dataByStyle[style] || {};
	const updateDataByStyleField = (field, value) => {
		setAttributes({
			dataByStyle: {
				...dataByStyle,
				[style]: {
					...currentData,
					[field]: value,
				},
			},
		});
	};

	// Fixed: Removed duplicate updateField function definition
	const scrollToInspectorControl = (sectionId) => {
		const inspectorElement = document.getElementById(`section${sectionId}`);
		if (inspectorElement) {
			inspectorElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
			inspectorElement.classList.add('inspector-highlight');
			setTimeout(() => {
				inspectorElement.classList.remove('inspector-highlight');
			}, 1000);
		}
	};

	// Smooth Scroll
	const scrollToSection = (sectionId) => {
		const targetElement = document.getElementById(sectionId);
		if (targetElement) {
			targetElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	};



	const containerRef = useRef(null);

	const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
	const adjustScale = () => {
		const minWidth = 320;
		const maxWidth = 1366;
		const minScale = 0.3;
		const refWidth1 = 992;
		const refScale1 = 0.468514;
		const refWidth2 = 1366;
		const refScale2 = 0.598237;
		const maxScale = 1;
	
		let scaleValue;
	
		if (viewportWidth <= refWidth1) {
			scaleValue =
				minScale +
				(refScale1 - minScale) *
					((viewportWidth - minWidth) / (refWidth1 - minWidth));
		} else if (viewportWidth <= refWidth2) {
			scaleValue =
				refScale1 +
				(refScale2 - refScale1) *
					((viewportWidth - refWidth1) / (refWidth2 - refWidth1));
		} else {
			scaleValue = Math.min(
				maxScale,
				refScale2 +
					(maxScale - refScale2) *
						((viewportWidth - refWidth2) / (maxWidth - refWidth2))
			);
		}
		if (containerRef.current) {
			const originalHeight = containerRef.current.scrollHeight;
			const scaledHeight = originalHeight * scaleValue;
	
			containerRef.current.style.transform = `scale(${scaleValue})`;
			containerRef.current.style.transformOrigin = '50% 0px';
			containerRef.current.style.transition = '0.5s ease-in-out';
	
			containerRef.current.style.maxHeight = `${scaledHeight}px`;
		}
	};
	
	// Handle resizing
	useEffect(() => {
		adjustScale();
	
		const handleResize = () => {
			setViewportWidth(window.innerWidth);
			adjustScale();
		};
	
		window.addEventListener('resize', handleResize);
	
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [viewportWidth]);

	
		
	return (
		<BlockContext.Provider
			value={{
				attributes,
				setAttributes,
				headerComponent,
				linkedinText,
				showSocialIcon,
				socialIconVisibility,
				updateField,
				emailPhoneVisibility,
				formatDate,
				footerVisibility,
				scrollToSection,
				formatDateDisplay,
				scrollToInspectorControl,
				containerRef,
				formatMonthDisplay,
				placeholderImageUrl,
				currentData,
				updateDataByStyleField,
				updateSectionTitle,
				captureRef,
			}}
		>
			<Fragment>
				{!userData.isAdmin && dashPreviewBanner && (
					<CustomPublishPreviewButtons />
				)}
				<style>{`${softMinifyCssStrings(blockStyleCss)}`}</style>
				{(() => {
					switch (style) {
						case 'style1':
						case 'style2':
						case 'style3':
						case 'style4':
						case 'style5':
						case 'style6':
						case 'style7':
						case 'style8':
						case 'style9':
						case 'style10':
						case 'style11':
						case 'style12':
						case 'style13':
						case 'style14':
						case 'style15':
						case 'style16':
						case 'style17':
						case 'style18':
						case 'style19':
						case 'style20':
						case 'style21':
						case 'style22':
						case 'style23':
						case 'style24':
						case 'style25':
						case 'style26':
						case 'style27':
						case 'style28':
							return <InspectorTwentyOne />;
						default:
							return <Inspector />;
					}
				})()}
				<div
					{...useBlockProps({
						className: `${uniqueId}`,
					})}
				>
					{(() => {
						switch (style) {
							case 'style21':
								return <TemplateTwentyOne />;
							case 'style1':
								return <TemplateStyleOne />;
							case 'style2':
								return <TemplateStyleTwo />;
							case 'style4':
								return <TemplateStyleFour />;
							case 'style5':
								return <TemplateStyleFive />;
							case 'style6':
								return <TemplateStyleSix />;
							case 'style7':
								return <TemplateStyleSeven />;
							case 'style8':
								return <TemplateStyleEight />;
							case 'style9':
								return <TemplateStyleNine />;
							case 'style10':
								return <TemplateTen />;
							case 'style11':
								return <TemplateEleven />;
							case 'style12':
								return <TemplateTwelve />;
							case 'style13':
								return <TemplateStyleThirteen />;
							case 'style14':
								return <TemplateStyleFourteen />;
							case 'style15':
								return <TemplateStyleFifteen />;
							case 'style16':
								return <TemplateStyleSixteen />;
							case 'style17':
								return <TemplateSeventeen />;
							case 'style18':
								return <TemplateStyleEighteen />;
							case 'style22':
								return <TemplateTwentyTwo />;
							case 'style23':
								return <TemplateTwentyThree />;
							case 'style24':
								return <TemplateTwentyFour />;
							case 'style25':
								return <TemplateTwentyFive />;
							case 'style26':
								return <TemplateOne />;
							case 'style27':
								return <TemplateTwo />;
							case 'style28':
								return <TemplateThree />;
							case 'style19':
								return <TemplateNineteen />;
							case 'style20':
								return <TemplateTwenty />;
							case 'style3':
								return <TemplateStyleThree />;
							default:
								return <MainTemplate />;
						}
					})()}
				</div>
			</Fragment>
		</BlockContext.Provider>
	);
}